/******************************************************************************

 @File         Ogl.ES2Navigation3D.cpp

 @Title        Navigation

 @Version      

 @Copyright    Copyright (c) Imagination Technologies Limited.

 @Platform     Independent

 @Description  Demonstrates a method of rendering a 3D navigation application
               using Opengl ES 2.0 and various culling techniques

******************************************************************************/

//import PVRShell from "./webgl/PVRShell"
import PVRTexture from "./webgl/Tools/PVRTexture"
import PVRShader from "./webgl/Tools/PVRShader"
import {PVRMatrix4x4, PVRMatrix3x3, PVRVector3, PVRVector2, PVRVector4} from "./webgl/Tools/PVRMaths"
import PVRFileStream from "./webgl/Tools/PVRFileStream"
import PVRMaths from "./webgl/Tools/PVRMaths"
import {PVRPrint3D, EPVRPrint3D} from "./webgl/Tools/PVRPrint3D"
//import PVRMesh from "./webgl/Tools/PVRMesh"
import PVRModel from "./webgl/Tools/PVRModel"
import {PVRPODLoader, EPODErrorCodes } from "./webgl/Tools/PVRPODLoader"
import PVR3dModelIndex from "./webgl/Tools/PVR3dModelIndex"
import PVROcclusion from "./webgl/Tools/PVROcclusion"
// import { array } from "prop-types"
// import { error } from "util"
import PVRModelShadow from "./webgl/Tools/PVRModelShadow"
import PVRSkybox from './webgl/Tools/PVRSkybox'

const WebglNavigation3DSim = function(data){





let documentData = data
   
let dataResult = function(thisdata, a, b)  {
     
    return   thisdata.filter(function(elt)  {
        return elt.endsWith(b) && elt.includes(a)
    })[0]
    }


const myresult = (documentData.allFile.edges.map((file, index) => {return (file.node.publicURL ) }))


let getFileLocation = function(name) {
	const dataResult = function(thisdata, a, b)  {
		return   thisdata.filter(function(elt)  {
			return elt.endsWith(b) && elt.includes(a)
		})[0]
		}
		let r1 = name.split(".")
		let l   = r1.length;
		let filename = r1[0];
		for (let i =1; i<l-1; i++) filename += r1[i];
		//let result = data.allFile.edges.map((file, index) => {return (file.node.publicURL ) })
			return (
				dataResult(myresult, r1[0],r1[l-1])
			)
		}





const FLT_MAX =  3.402823466e+38;
const USE_INFINITE_FAR_PLANE = false;

//#define ENABLE_UI
//#define ENABLE_ADVANCED_OUTPUT

/******************************************************************************
 Constants
******************************************************************************/
const  c_UserCameraMovementSpeed = 2;
const  c_CameraMovementSpeedScale = 0.075;
const  c_fShadowVolumesMaxDistance = 0.25;

/******************************************************************************
 Defines
******************************************************************************/

const PVRTSHADOWVOLUME_VISIBLE  = 0x01;
const PVRTSHADOWVOLUME_NEED_CAP_FRONT  = 0x02;
const PVRTSHADOWVOLUME_NEED_CAP_BACK = 0x04;



// Index the attributes that are bound to vertex shaders
const VERTEX_ARRAY	=  0
const NORMAL_ARRAY =	 1
const TEXCOORD_ARRAY =  2

const VERTEX_ARRAY_UI	=  0
const TEXCOORD_ARRAY_UI  = 1

// Culling results
const INTERSECT_NONE  =  0
const INTERSECT_PARTIAL = 1
const INTERSECT_FULL  =  2

// Button and feature IDs
const STATE_PAUSE   =   0
const STATE_SHADOW   =  1
const STATE_DEBUG    =  2
const STATE_CULLING  =  3
const STATE_OCCLUSION = 4
const STATE_INPUT_MODE = 5
const STATE_UI        = 6
const NUM_STATES     =  7

/****************************************************************************
** Structures
****************************************************************************/

/*!***********************************************************************
 *	@Struct PVRTModelVertex
 ************************************************************************/
let PVRTModelVertex =function()
{
	
	this.position = new PVRVector3();
	 this.normal = new PVRVector3();
	 this.texcoord= new PVRVector2();


};
let SNormalOffset = 12;
let STexCoordOffset = 24;

// /*!***********************************************************************
//  *	@Struct PVRTBoundingBox2D
//  ************************************************************************/
let PVRTBoundingBox2D = function()
{
	// Min and max coordinates
	this.minCoords = new PVRVector2();
	this.maxCoords = new PVRVector2();
};

/*!***********************************************************************
 *	@Struct PVRTBoundingBox3D
 ************************************************************************/
let PVRTBoundingBox3D = function()
{
	// Min and max coordinates
	this.minCoords = new PVRVector3();
	this.maxCoords =new PVRVector3();
};

/*!***********************************************************************
 *	@Struct PVRTVisibilityInfo
 *  @Brief  Used to store the visible city blocks and the chosen level of detail.
 ************************************************************************/
let  PVRTVisibilityInfo = function()
{
	            this.tile = 0; // int
	this.lod = 0; //unsigned short 
	 this.visibility = 0;//unsigned short;
};


// /*!**************************************************************************
//  *	@Struct PVRTCityBlockEntity
//  *  @Brief  Describes an element of a city block (roads/buildings/landmarks/etc).
//  *          Contains the bounding box for efficient culling, a reference index
//  *          for the original Collada node and various attributes required for rendering.
//  ****************************************************************************/
// let PVRTCityBlockEntity = function()
// {
// 	 this.boundingbox = new PVRTBoundingBox2D();
//       this.numSubObjects = 0; //	PVRTuint32  
// 	   this.pNodeIdx  = new Uint32Array(); // unsigned int  * 
//        	this.paNumIndices = new Uint32Array();// unsigned int  *;
// 	   this.paIndexOffsets = new Uint32Array();  //unsigned int  *
// 	      this.pauiTextures= new Uint32Array(); // gluint     *
// };

// /*!**************************************************************************
//  *	@Struct PVRTCityBlockLod
//  *  @Brief  A model tile LOD stores the filename of the POD file and various
//  *          attributes like the number of (parent) objects it contains.
//  *          Furthermore it stores two Opengl buffer object identifiers, one
//  *          for the vertex and another one for the index data.
//  *          The last members keep a list of visible nodes which are determined
//  *          in a seperate visibility update pass.
//  ****************************************************************************/
// let PVRTCityBlockLod = function()
// {
// 	this.pszFilename =  new Uint8Array(); //char               *
// 	this.numObjects  = 0 ;   // PVRTuint32    
// 	this.paObjects = [];   //PVRTCityBlockEntity *
// 	this.vbos = new Uint32Array(2); //gluint [2]
// 	this.paVisibleNodes = new Uint32Array(); //unsigned int       *
// 	this.numVisibleNodes = 0;  //unsigned int   
//      this.bLoaded = false;//bool    
// };

// /*!**************************************************************************
//  *	@Struct PVRTCityBlock
//  *	@Brief  A city block is a container for all models located within a certain
//  *          region of the city defined by a bounding box. There can be several
//  *          levels of detail for each city block.
//  ****************************************************************************/
// let PVRTCityBlock = function()
// {
// 	this.boundingbox = new PVRTBoundingBox2D();
//      this.numLod = 0;  //	PVRTuint32   
// 	this.paLod = [];   //PVRTCityBlockLod *
// };

// /*!**************************************************************************
//  *	@Struct PVRTOcclusionData
//  *	@Brief  TODO
//  ****************************************************************************/
// let PVRTOcclusionData = function()
// {
// 	this.position = new PVRVector3();
// 	this.numRefObjects = 0; //unsigned int 
// 	this.pRefTile = new Uint32Array();  //unsigned int *
// 	this.pNumRefObject = new Uint32Array();//  unsigned int *
// 	this.ppRefObjects = new Uint32Array();// unsigned int  **
// };

/*!**************************************************************************
 *	@Struct ShaderDescription
 *	@Brief  This structure describes a shader program and is just used to
 *          conveniently store each available shader.
 ****************************************************************************/
let ShaderDescription = function(pszVSSF, pszVSBF, pszFSSF, pszFSBF, ui32NA, pszA)
{
	this.pszVertShaderSrcFile= pszVSSF;
	this.pszVertShaderBinFile= pszVSBF;
	this.pszFragShaderSrcFile= pszFSSF;
	this.pszFragShaderBinFile= pszFSBF;
	this.ui32NumAttributes= ui32NA;
	this.pszAttributes = pszA;
};


/******************************************************************************
  Functions
******************************************************************************/

WebglNavigation3DSim.PointInBoundingBox = function(p, bbox) //(new PVRVector2 p, PVRTBoundingBox2D bbox)
{
	if (p.data[0] < bbox.minCoords.data[0] || p.data[1] < bbox.minCoords.data[1] || p.data[0] > bbox.maxCoords.data[0] || p.data[1] > bbox.maxCoords.data[1])
		return false;
	else
		return true;
}

/******************************************************************************
 Content file names
******************************************************************************/

let g_pszAttributes = [ "inVertex", "inNormal", "inTexCoord" ];
let g_pszTexAttributes = ["inVertex", "inTexCoord" ];
let g_pszShadowAttributes = [ "inVertex", "inExtrude" ];

let  CityEntityShaderDescription = new ShaderDescription( "BuildingVertShader.vsh",   "BuildingVertShader.vsc",   "BuildingFragShader.fsh", "BuildingFragShader.fsc",  3, g_pszAttributes );
let  SkyboxShaderDescription  = new ShaderDescription      ( "SkyboxVertShader.vsh",     "SkyboxVertShader.vsc",     "SkyboxFragShader.fsh",   "SkyboxFragShader.fsc",    1, g_pszAttributes );
let  FullscreenShaderDescription = new  ShaderDescription  ( "FullscreenVertShader.vsh", "FullscreenVertShader.vsc", "FullscreenFragShader.fsh", "FullscreenFragShader.fsc", 2, g_pszTexAttributes );
let  ShadowVolShaderDescription =  new ShaderDescription   ( "ShadowVolVertShader.vsh",  "ShadowVolVertShader.vsc",  "ShadowVolFragShader.fsh",   "ShadowVolFragShader.fsc", 2, g_pszShadowAttributes );
let  UIShaderDescription  =  new ShaderDescription         ( "UIVertShader.vsh", "UIVertShader.vsc", "UIFragShader.fsh", "UIFragShader.fsc", 2, g_pszTexAttributes );

// Textures
let c_szTextureNameSkybox = getFileLocation("Skybox.pvr");
let c_szTextureNameUI =  getFileLocation("UIElements.pvr");

// Scene files
let c_szTrackFile = getFileLocation("cameratrack.pod");
let c_szModelIndexFilename = getFileLocation("modelindex.nav");
let c_szOcclusionDataFilename = getFileLocation("occlusiondata.nav");

// Texture files required for the city model
let c_paszTextures = [ "006_RUS.PNG",  "007_RUG.PNG", "008_RUG.PNG", "009_RUG.PNG", "011_GIE.PNG", "012_RSR.PNG", "016_FOC.PNG", "016_RTR.PNG", "017_FOD.PNG",
                                 "018_FOD.PNG", "019_FOC.PNG", "019_GOC.PNG", "019_RZG.PNG", "020_FOC.PNG", "021_FOC.PNG", "022_FOC.PNG", "022_RUG.PNG",
                                 "023_FOB.PNG", "023_RUG.PNG", "024_FOB.PNG", "025_FOC.PNG", "025_RUW.PNG", "026_FOD.PNG", "026_RUW.PNG", "027_FOD.PNG",
                                 "027_RUW.PNG", "028_GOF.PNG", "029_GCC.PNG", "030_GOC.PNG", "031_GOD.PNG", "032_FOC.PNG", "032_GOC.PNG", "033_FOA.PNG",
                                 "033_GOA.PNG", "034_FOC.PNG", "034_GOC.PNG", "035_FOC.PNG", "035_GOC.PNG", "036_FOC.PNG", "036_GOC.PNG", "037_FOC.PNG",
                                 "037_GOC.PNG", "041_FRB.PNG", "041_GRB.PNG", "044_GRC.PNG", "046_GRC.PNG", "055_GRC.PNG", "056_GRC.PNG", "060_FRC.PNG", "063_GRC.PNG",
                                 "064_GRC.PNG", "066_FCB.PNG", "066_GCB.PNG", "067_FCC.PNG", "067_GCC.PNG", "068_GCD.PNG", "069_FCA.PNG", "069_GCA.PNG",
                                 "070_GOD.PNG", "071_FRC.PNG", "072_FRC.PNG", "073_FRC.PNG", "074_FRC.PNG", "075_FRC.PNG", "076_FRC.PNG", "077_FRC.PNG",
                                 "080_GCB.PNG", "083_FRC.PNG", "085_GRC.PNG", "086_FOF.PNG", "086_GOF.PNG", "087_FCA.PNG", "087_GCA.PNG", "087_GCC.PNG",
								 "054_GRC.PNG", "059_FRC.PNG", "061_FRD.PNG", "082_FCD.PNG", "088_FRC.PNG", "089_FRC.PNG", "092_GCA.PNG", "094_FOD.PNG", "095_FOD.PNG",
								 "US_IL_CHICAGO_MMART_L.PNG", "US_IL_13443_CHICAGO_35EAST_L.PNG", "US_IL_13444_CHICAGO_LEOBURNETT_L.PNG",
                                 "US_IL_13447_CHICAGO_REIDMURDOCH_L.PNG", "US_IL_13448_CHICAGO_CARBIDE_L.PNG", "US_IL_13449_CHICAGO_CROWNFOUNTAIN_L.PNG",
                                 "US_IL_13451_CHICAGO_CULTURAL_L.PNG", "US_IL_13453_CHICAGO_PRUDENTIAL_PART1_L.PNG", "US_IL_13454_CHICAGO_UNITED_L.PNG",
								 "US_IL_13458_CHICAGO_SMURFIT_L.PNG", "US_IL_13459_CHICAGO_LASALLE_L.PNG", "US_IL_13461_CHICAGO_UNITRIN_L.PNG", "US_IL_13462_CHICAGO_WILLOUGHBY_L.PNG",
								 "US_IL_13490_CHICAGO_PRUDENTIAL_PART2_L.PNG", "US_IL_CHICAGO_AONCENTER_L.PNG", "US_IL_CHICAGO_ARTINSTITUTE_L.PNG", "US_IL_CHICAGO_BOARDOFTHETRADE_L.PNG",
								 "US_IL_CHICAGO_BOEINGBUILDING_L.PNG", "US_IL_CHICAGO_CHICAGOTHEATRE_L.PNG", "US_IL_CHICAGO_CITYHALL_L.PNG", "US_IL_CHICAGO_DALEY_L.PNG",
								 "US_IL_CHICAGO_HILTON_L.PNG", "US_IL_CHICAGO_JAMESTHOMPSON_L.PNG", "US_IL_CHICAGO_LIBRARY_L.PNG", "US_IL_CHICAGO_MILLENIUMPARK1_L.PNG",
								 "US_IL_CHICAGO_MILLENIUMPARK2_L.PNG", "US_IL_CHICAGO_OGILVIE_L.PNG", "US_IL_CHICAGO_SEARSTOWER_L.PNG", "US_L_CONCRETE-COLOUR.PNG",
								 "US_L_CONCRETE-DETAIL.PNG", "US_L_PARK-COLOUR.PNG", "US_L_WATER-COLOUR.PNG", "US_R_CONCRETE.PNG", "US_R_STREET-DASHED.PNG", "US_R_STREET-INNER-SHOULDER.PNG",
								 "US_R_STREET-LANE-FILLER.PNG", "US_R_STREET-SOLID.PNG", "US_R_STREET-UNMARKED.PNG", "US_R_WALKWAY-SOLID.PNG", "US_R_WALKWAY-UNMARKED.PNG", "US_T_RAILROAD.PNG",
                                 "US_R_HIGHWAY-SOLID.PNG", "US_IL_CHICAGO_UNIONSTATION_L.PNG", "US_IL_13460_CHICAGO_TRUMP_L.PNG", "US_IL_13456_CHICAGO_SEVENTEENTH_L.PNG" ];

/*!****************************************************************************
 Class declarations
******************************************************************************/

/*!***********************************************************************
 *	@Class  OglES2Navigation3D
 *	@Brief  Navigation demo main class.
 ************************************************************************/

	// Print3D class used to display text
	 let m_Print3D  = new PVRPrint3D(myresult); //CPVRTPrint3D;

	// Camera attributes
	let       m_fCameraAnimation = 0;


	

	let          m_bRotate = false;
	
	let      m_vCameraFrom = new PVRVector3();
	let      m_vCameraTo = new PVRVector3();
	let      m_vCameraUp = new PVRVector3();

	let      m_vLightDirection = new PVRVector3();

	// Viewing matrices
	let     m_mViewMatrix =  new PVRMatrix4x4();
	let     m_mProjectionMatrix = new PVRMatrix4x4();
	let     m_mViewProjectionMatrix= new PVRMatrix4x4();
	let     m_mViewProjectionMatrixNonRotated = new PVRMatrix4x4();


	// 3D Models
//	let       m_uiNumPVRTCityBlocks = 0;
//	let       this.m_paPVRTCityBlocks =  [] ;   //PVRTCityBlock *

	let    m_uiNumVisibleTiles =0 ;

	


	// Skybox
	let     m_uiSkyboxVBO = {};
	

	// Textures
	let m_uiNumTextures = 0;
	//let m_pauiTextureIds = new Uint32Array(); //gluint      *

	// General options
	 let m_abStates = new  Uint8Array(NUM_STATES); //bool

	// Mouse input
	let     m_bMousePressed = false;
	let m_ulLastMouseClick = 0; //unsigned long
	let m_vMouseClickPos = new PVRVector2();
	let m_vMousePrevPos = new PVRVector2();

	let m_mMouseLookMatrix = new PVRMatrix4x4();
	let m_mMouseLightMatrix = new PVRMatrix4x4();

	// Shadow volumes
	let  m_bUpdateShadowData = false
	
	
	

	let m_Buttons = new  Array(NUM_STATES);//  PVRTBoundingBox2D();


   let m_ButtonCoordinates = new Array(NUM_STATES);//  new PVRVector2();[NUM_STATES][4]

   let m_ButtonTexCoords = new Array(NUM_STATES);           ;// new PVRVector2();[NUM_STATES][4]

	    

	// Shader objects
	let Shader = function()
	{
		this.uiId = 0;
		this.uiVertexShaderId = 0;
		this.uiFragmentShaderId = 0;
	};

	let SkyboxShader = function()
	{
		this.uiId = 0;
		this.uiVertexShaderId = 0;
		this.uiFragmentShaderId = 0;
		this.uiModelViewProjMatrixLoc = 0;
	}
	let m_SkyboxShader = new SkyboxShader();

	let ModelShader = function()
	{
		this.uiId = 0;
		this.uiVertexShaderId = 0;
		this.uiFragmentShaderId = 0;
		this.uiModelViewProjMatrixLoc=0;
		this.uiLightDirectionLoc=0;
	}
	let m_CityEntityShader = new ModelShader();

	let ShadowVolShader = function()
	{
		this.uiId = 0;
		this.uiVertexShaderId = 0;
		this.uiFragmentShaderId = 0;
		this.uiModelViewProjMatrixLoc=0;
		this.uiLightDirectionLoc=0;
		this.uiVolumeScaleLoc=0;
		this.uiColourLoc=0;
	}
	let m_ShadowVolShader = new ShadowVolShader()

	let  FullscreenShader =function()
	{
		this.uiId = 0;
		this.uiVertexShaderId = 0;
		this.uiFragmentShaderId = 0;
		this.uiColourLoc=0;
	}
	let m_FullscreenShader = new FullscreenShader()

	let UIShader  = function()

	{
		this.uiId = 0;
		this.uiVertexShaderId = 0;
		this.uiFragmentShaderId = 0;
		this.uiRoationMatrixLoc = 0;
		this.uiColourScaleLoc= 0;
	}
	let m_UIShader = new UIShader()

	let  m_ui32InitState = 0;
	let m_ui32TextureBase = 0;
	let m_ui32BlockBase = 0;
	




	

	

	












	



	












/*!****************************************************************************
 @Function		LoadAssets
 @Output		finished		True if loading has finished, false otherwise.
 @Return		bool			true if no error occures
 @Description	Loads the assets required for the demo and display progress
                messages.
******************************************************************************/
//bool OglES2Navigation3D::LoadAssets(bool &finished)
WebglNavigation3DSim.prototype.loadAssets = function(gl)
{
	
	this.loading_finished = false;

	// Print the message that we will load the textures in the next iteration
	if (m_ui32InitState === 0)
	{
		gl.clear(gl.COLOR_BUFFER_BIT);
		m_Print3D.displayDefaultTitle("3D Navigation", null, EPVRPrint3D.Logo.PowerVR);
		m_Print3D.print3D(35.0, 45.0, 1.0, 0xFFFFFFFF, "PLEASE WAIT");
		m_Print3D.print3D(35.0, 55.0, 0.5, 0xAAFFFFFF, "Loading textures ...");
		m_Print3D.flush(gl);
		m_ui32InitState += 1;

		return true;
	}
	// Print the message that we will load the models in the next iteration and
	// actually load the textures now
	else if (m_ui32InitState === 1)
	{
		const numTexturesIteration = 5;
		
		// Load all 3d model textures
		//char buffer[512];
		for (let i=0; i < numTexturesIteration; ++i)
		{
			// Loaded all textures
			if (m_ui32TextureBase >=  m_uiNumTextures )
			{
				if(this.LoadingTextures <= 0) {	
				//	//console.log("loading Texture");
					++m_ui32InitState;}
				break;
			}
			let buffer = getFileLocation( c_paszTextures[m_ui32TextureBase] + ".pvr");
			(function(index, demo)
			{
				PVRTexture.loadFromURI(gl, buffer, 0,
					function(gl, id, h, m)
					{
						//demo.auiTextureIds[index] = id;
					
						demo.m_pauiTextureIds[index] = id;
					
						//Clear the bit that denotes that this texture is loaded
						demo.LoadingTextures  -= 1; //&= ~(1<<(index+2));
			
						if(gl.getError()) { alert("Error while loading texture!" + c_paszTextures[index]); }

						gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
			        	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
			 	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
			    	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
					
					});
			})(m_ui32TextureBase, this);


			// if (PVR_SUCCESS == PVRTTextureLoadFromPVR(buffer, m_pauiTextureIds[m_ui32TextureBase]))
			// {
			// 	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
			// 	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
			// 	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
			// 	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
			// }
			// else
			// {
			// 	PVRShellOutputDebug("Failed to load texture: %s\n", buffer);
			// }

			++m_ui32TextureBase;
		}
	
		gl.clear(gl.COLOR_BUFFER_BIT);
		m_Print3D.displayDefaultTitle("3D Navigation", null, EPVRPrint3D.Logo.PowerVR);
		m_Print3D.print3D(35.0, 45.0, 1.0, 0xFFFFFFFF, "PLEASE WAIT ...");
	//	m_Print3D.print3D(35.0, 55.0, 0.5, 0xAAFFFFFF, "Loading textures ... ("+ m_ui32TextureBase.toString() + "/" +m_uiNumTextures.toString() + ")" );
	m_Print3D.print3D(35.0, 55.0, 0.5, 0xAAFFFFFF, "Loading textures ... (" + parseInt((m_ui32TextureBase * 100.0 / m_uiNumTextures).toString() , 10).toString() + "% )");
		
		
		
		m_Print3D.flush(gl);
	
		return true;
	}// Load the models and indicate that we are finished afterwards
	else if (m_ui32InitState === 2)
	{
		if (m_ui32BlockBase >= this.m_uiNumPVRTCityBlocks)
		{
			if (this.totalLoadVBO <= 0){
			
                for (let i=0; i < this.m_uiNumPVRTCityBlocks; ++i){
				for (let j=0; j < this.m_paPVRTCityBlocks[i].numLod; ++j)
				{
					let pLod = this.m_paPVRTCityBlocks[i].paLod[j];
					if (pLod.array  && pLod.pIndices){
					let  array = pLod.array;
					let  pIndices = pLod.pIndices;
					 pLod.vbos[0] = gl.createBuffer();
					 pLod.vbos[1] = gl.createBuffer();
				
				
					 gl.bindBuffer(gl.ARRAY_BUFFER, pLod.vbos[0]);
					 gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, pLod.vbos[1]);
					
					// //gl.bufferData(gl.ARRAY_BUFFER, totalVertexCount * sizeof(PVRTModelVertex), pVertices, gl.STATIC_DRAW);
					 gl.bufferData(gl.ARRAY_BUFFER,  array.buffer , gl.STATIC_DRAW);
					// //gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, totalIndexCount * sizeof(gl.ushort), pIndices, gl.STATIC_DRAW);
					 gl.bufferData(gl.ELEMENT_ARRAY_BUFFER,  pIndices.buffer, gl.STATIC_DRAW);
					
					 
					}
				}
			}
					gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
					gl.bindBuffer(gl.ARRAY_BUFFER, null);
				
					  ;

					m_ui32BlockBase = 0;
				m_ui32InitState++;
			}
			return true;
		}
		else
		{
			


			 for (let j=0; j < this.m_paPVRTCityBlocks[m_ui32BlockBase].numLod; ++j)
			 {
				this.createModelVbo(gl, m_ui32BlockBase, j);
        // if (this.completeVBO != this.totalLoadVBO) {
		// 	m_ui32InitState++; 
		// }
 

			}
		//this.createModelVbo(gl, m_ui32BlockBase, 0);
		//	this.createShadowVolumes(m_ui32BlockBase);

			m_ui32BlockBase += 1;


			gl.clear(gl.COLOR_BUFFER_BIT);
			m_Print3D.displayDefaultTitle("3D Navigation", null, EPVRPrint3D.Logo.PowerVR);
			m_Print3D.print3D(35.0, 45.0, 1.0, 0xFFFFFFFF, "PLEASE WAIT ...");
			m_Print3D.print3D(35.0, 55.0, 0.5, 0xAAFFFFFF, "Loading textures ... done");
			m_Print3D.print3D(35.0, 59.0, 0.5, 0xAAFFFFFF, "Loading models ...(" + parseInt((m_ui32BlockBase * 100.0 / this.m_uiNumPVRTCityBlocks).toString(), 10).toString()  + "% )" );
			m_Print3D.flush(gl);
			return true;
		}
	}
    else if (m_ui32InitState === 3){


		if (m_ui32BlockBase >= this.m_uiNumPVRTCityBlocks){
		
		if (this.completeVBO <= 0){
			this.updateShadowVolumes(gl);
			m_ui32InitState += 1;
  
		}
	
	}
	 else{

		
		
	// for (let j=0; j < this.m_uiNumPVRTCityBlocks; ++j)
	// 	{	
			
	// 		//console.log("create",j);
			this.createShadowVolumes(gl, m_ui32BlockBase++);
			//m_ui32BlockBase++;
	//   }
	
	  // m_ui32BlockBase = this.m_uiNumPVRTCityBlocks


	  gl.clear(gl.COLOR_BUFFER_BIT);
			m_Print3D.displayDefaultTitle("3D Navigation", null, EPVRPrint3D.Logo.PowerVR);
			m_Print3D.print3D(35.0, 45.0, 1.0, 0xFFFFFFFF, "PLEASE WAIT ...");
			m_Print3D.print3D(35.0, 55.0, 0.5, 0xAAFFFFFF, "Loading textures ... done");
			m_Print3D.print3D(35.0, 59.0, 0.5, 0xAAFFFFFF, "Loading models ... done" );
		//	m_Print3D.print3D(35.0, 63.0, 0.5, 0xAAFFFFFF, "Loading shadows  ...(" + m_ui32BlockBase.toString() + "/" + this.m_uiNumPVRTCityBlocks.toString() + ")" );
			m_Print3D.print3D(35.0, 63.0, 0.5, 0xAAFFFFFF, "Loading shadows  ...(" + parseInt((m_ui32BlockBase * 100.0 / this.m_uiNumPVRTCityBlocks).toString(),10).toString() + "% )" );
			
			m_Print3D.flush(gl);
			return true;

	}
return true;
	}

	
	return false;
}





/*!****************************************************************************
 @Function		LoadTextures
 @Output		pErrorStr		A string describing the error on failure
 @Return		bool			true if no error occured
 @Description	Loads the textures required for this training course
******************************************************************************/
//bool OglES2Navigation3D::LoadTextures(CPVRTString* const pErrorStr)
WebglNavigation3DSim.prototype.loadTextures = function(gl)

{
	// if (PVRTTextureLoadFromPVR(c_szTextureNameSkybox, this.m_uiTextureIdSkybox) != PVR_SUCCESS)
	// {
	// //console.log("ERROR: Could not open texture file " + c_szTextureNameSkybox);
	// 	return false;
	// }

	(function( demo)
	{

		
		////console.log("first",c_szTextureNameSkybox);
		PVRTexture.loadFromURI(gl, c_szTextureNameSkybox, 0,
			function(gl, id, h, m)
			{
				//////console.log("loaded first");
				demo.m_uiTextureIdSkybox = id;
				//Clear the bit that denotes that this texture is loaded
				demo.LoadingTextures -=1; //&= ~(1<<0);
				
				if(gl.getError()) { alert("Error while loading texture!"); }
				gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
				gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
				gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
				gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
				
			});
	})( this);


// 	(function( demo)
// 	{
// 	PVRTexture.loadFromURI(gl, c_szTextureNameUI, 0,
// 		function(gl, id, h, m)
// 		{
// 			////console.log("loaded first");
// 			demo.m_uiTextureIdUI = id;
// 			//Clear the bit that denotes that this texture is loaded
// 			demo.LoadingTextures -=1; //&= ~(1<<0);
			
// 			if(gl.getError()) { alert("Error while loading texture!"); }
// 			gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
// 			gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
// 			gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
// 			gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
			
// 		});
// })( this);


	(function( demo)
	{
		
		PVRTexture.loadFromURI(gl, c_szTextureNameUI, 0,
			function(gl, id, h, m)
			{
		
				demo.m_uiTextureIdUI = id;
				//Clear the bit that denotes that this texture is loaded
				demo.LoadingTextures  -= 1;//&= ~(1<<1);
				////console.log("second");
				if(gl.getError()) { alert("Error while loading texture!"); }
				gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
			
			});
	})( this);

//#ifdef ENABLE_UI
	// if (PVRTTextureLoadFromPVR(c_szTextureNameUI, m_uiTextureIdUI) != PVR_SUCCESS)
	// {
	// 	////console.log("ERROR: Could not open texture file " + c_szTextureNameUI);
	// 	return false;
	// }


//#endif // ENABLE_UI

	return true;
}


/*!****************************************************************************
 @Function		LoadShader
 @Output		pErrorStr		A string describing the error on failure
 @Input 		descr		    A struct containing all necessary information to
                                load and build the shader
 @Output		shader		    A struct containing all shader object identifiers
 @Return		bool			true if no error occured
 @Description	Loads and compiles a shader and links it into a shader program
******************************************************************************/
//bool OglES2Navigation3D::LoadShader(CPVRTString* pErrorStr, const ShaderDescription &descr, Shader &shader)
WebglNavigation3DSim.prototype.loadShader = function(gl ,  descr, shader)
{


	shader.uiVertexShaderId = PVRShader.loadFromURI(gl, getFileLocation( descr.pszVertShaderSrcFile) , gl.VERTEX_SHADER, [], function(e){alert(e);});

	// if (PVRTShaderLoadFromFile(descr.pszVertShaderBinFile, descr.pszVertShaderSrcFile, gl.VERTEX_SHADER, gl.SGX_BINARY_IMG, shader.uiVertexShaderId, pErrorStr) != PVR_SUCCESS)
	// {
	// 	//ErrorStr = descr.pszVertShaderSrcFile + CPVRTString(":\n") + *pErrorStr;
	// 	return false;
	// }
	shader.uiFragmentShaderId = PVRShader.loadFromURI(gl, getFileLocation(descr.pszFragShaderSrcFile), gl.FRAGMENT_SHADER, [], function(e){alert(e);});

	// if (PVRTShaderLoadFromFile(descr.pszFragShaderBinFile, descr.pszFragShaderSrcFile, gl.FRAGMENT_SHADER, gl.SGX_BINARY_IMG, shader.uiFragmentShaderId, pErrorStr) != PVR_SUCCESS)
	// {
	// 	//*pErrorStr = descr.pszFragShaderSrcFile + CPVRTString(":\n") + *pErrorStr;
	// 	return false;
	// }

	// Set up and link to the shader program
	shader.uiId = PVRShader.createProgram(gl,  shader.uiVertexShaderId, shader.uiFragmentShaderId, descr.pszAttributes, function(e){alert(e);});


	// if (PVRTCreateProgram(shader.uiId, shader.uiVertexShaderId, shader.uiFragmentShaderId, descr.pszAttributes, descr.ui32NumAttributes, pErrorStr))
	// {
	// 	//*pErrorStr = descr.pszFragShaderSrcFile + CPVRTString(":\n") + *pErrorStr;
	// 	return false;
	// }

	return true;
}

/*!****************************************************************************
 @Function		LoadShaders
 @Output		pErrorStr		A string describing the error on failure
 @Return		bool			true if no error occured
 @Description	Loads and compiles shaders and links them to shader programs
******************************************************************************/
//bool OglES2Navigation3D::LoadShaders(CPVRTString* pErrorStr)
WebglNavigation3DSim.prototype.loadShaders = function(gl )
{

	//	Load and compile the shaders from files.
	//	Binary shaders are tried first, source shaders are used as fallback.

	// CityEntityShader
	//
	if (!this.loadShader(gl, CityEntityShaderDescription, m_CityEntityShader))
	{
		//console.log("Shader compilation failed: CityEntityShader\n");
		//PVRShellSet(prefExitMessage, pErrorStr.c_str());
		return false;
	}

	m_CityEntityShader.uiModelViewProjMatrixLoc = gl.getUniformLocation(m_CityEntityShader.uiId, "ModelViewProjMatrix");
	m_CityEntityShader.uiLightDirectionLoc      = gl.getUniformLocation(m_CityEntityShader.uiId, "LightDirection");
	gl.uniform1i(gl.getUniformLocation(m_CityEntityShader.uiId, "sTexture"), 0);

	//  SkyboxShader
	//
	if (!this.loadShader(gl, SkyboxShaderDescription, m_SkyboxShader))
	{
		//console.log("Shader compilation failed: SkyBoxShader\n");
		//PVRShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}
	//console.log("loading shader.....2");
	m_SkyboxShader.uiModelViewProjMatrixLoc = gl.getUniformLocation(m_SkyboxShader.uiId, "ModelViewProjMatrix");
	gl.uniform1i(gl.getUniformLocation(m_SkyboxShader.uiId, "sCubeMap"), 0);


	// ShadowVolShader
	//
	if (!this.loadShader(gl, ShadowVolShaderDescription, m_ShadowVolShader))
	{
		//console.log("Shader compilation failed: ShadowVolShader\n");
		//PVRShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}
	//console.log("loading shader.....3");
	m_ShadowVolShader.uiModelViewProjMatrixLoc = gl.getUniformLocation(m_ShadowVolShader.uiId, "ModelViewProjMatrix");
	m_ShadowVolShader.uiLightDirectionLoc      = gl.getUniformLocation(m_ShadowVolShader.uiId, "LightDirection");
	m_ShadowVolShader.uiVolumeScaleLoc         = gl.getUniformLocation(m_ShadowVolShader.uiId, "VolumeScale");
	m_ShadowVolShader.uiColourLoc              = gl.getUniformLocation(m_ShadowVolShader.uiId, "FlatColour");

	// FullscreenShader
	//
	if (!this.loadShader(gl, FullscreenShaderDescription, m_FullscreenShader))
	{
		//console.log("Shader compilation failed: FullscreenShader\n");
		//PVRShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}
	//console.log("loading shader.....4");
	m_FullscreenShader.uiColourLoc  = gl.getUniformLocation(m_FullscreenShader.uiId, "FlatColour");
	gl.uniform1i(gl.getUniformLocation(m_FullscreenShader.uiId, "sTexture"), 0);

//#ifdef ENABLE_UI
	// UIShader
	//
	if (!this.loadShader(gl, UIShaderDescription, m_UIShader))
	{
		//console.log("Shader compilation failed: UIShader\n");
		//PVRShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}
	//console.log("loading shader.....5");
	m_UIShader.uiRoationMatrixLoc = gl.getUniformLocation(m_UIShader.uiId, "RotationMatrix");
	m_UIShader.uiColourScaleLoc = gl.getUniformLocation(m_UIShader.uiId, "ColourScale");
	gl.uniform1i(gl.getUniformLocation(m_UIShader.uiId, "sTexture"), 0);
//#endif // ENABLE_UI

	return true;
}



let loadPOD = function(stream, demo)
    {
		// //console.log(demo);
		// //console.log(demo.m_CameraPod);
		demo.m_CameraPod = new PVRModel();
	
		let podLoader    = new PVRPODLoader();
		let result       = podLoader.load(stream, demo.m_CameraPod);
		if(result !== EPODErrorCodes.eNoError)
		{
			alert("Failed to load POD: " + result);
			return;
		}

        // Retrieve node indexes
	    // for(let i = 0; i < ENodeNames.eNODE_SIZE; ++i)
	    // {
		//     for(let j = 0; j < demo.m_CameraPod.data.numNodes; ++j)
		//     {
		// 	    let node = demo.m_CameraPod.data.nodes[j];
		// 	    if(node.data.name === demo.c_aszNodeNames[i])
		// 	    {
		// 		    demo.NodeIndexName[j] = i;
		// 		    demo.NodeNameIndex[i] = j;
		//     	}
		//     }
	    // }

		let c_uiCamera = 0;
		
	//	let i32CamID = demo.m_CameraPod.data.nodes[demo.m_CameraPod.data.numMeshNodes + demo.m_CameraPod.data.numLights + c_uiCamera].data.index;

        // Get the camera position, target and field of view
      //  if(demo.m_CameraPod.data.cameras[i32CamID].data.targetIndex != -1){
	let props = 	demo.m_CameraPod.getCameraProperties(c_uiCamera);

	demo.m_ActiveCameraTrack = 0;
	demo.m_fNearClipPlane =  demo.m_CameraPod.data.cameras[c_uiCamera].data.near; //pCamera.fNear;
	demo.m_fFarClipPlane = demo.m_CameraPod.data.cameras[c_uiCamera].data.far;
	demo.m_fFOV = props.fov;//demo.m_CameraPod.data.cameras[c_uiCamera].data.fFOV;

	//	}
	// const int cmdargs = PVRShellGet(prefCommandLineOptNum);
	// const SCmdLineOpt *pCmdLine = (const SCmdLineOpt *)PVRShellGet(prefCommandLineOpts);
	// for (int i=0; i < cmdargs; i++)
	// {
	// 	if (strcmp(pCmdLine[i].pArg, "-far") == 0)
	// 	{
	// 		PVRShellOutputDebug("Info: Changing far clip plane from %.0f to %s\n", m_fFarClipPlane, pCmdLine[i].pVal);
	// 		m_fFarClipPlane = (float)atoi(pCmdLine[i].pVal);
	// 	}
	// 	if (strcmp(pCmdLine[i].pArg, "-near") == 0)
	// 	{
	// 		PVRShellOutputDebug("Info: Changing near clip plane from %.0f to %s\n", m_fNearClipPlane, pCmdLine[i].pVal);
	// 		m_fNearClipPlane = (float)atoi(pCmdLine[i].pVal);
	// 	}
	// }

	let m_afLodDistances = new Float32Array(2)     ;
	demo.m_afSquaredLodDistances = new Float32Array(2)     ;
	
	m_afLodDistances[0] =  (demo.m_fFarClipPlane + demo.m_fNearClipPlane) * 0.5;//(demo.m_CameraPod.pCamera.fFar + demo.m_CameraPod.pCamera.fNear) * 0.5;
	
	
	m_afLodDistances[1] =  demo.m_fFarClipPlane; //demo.m_CameraPod.pCamera.fFar;
	
	
	demo.m_afSquaredLodDistances[0] = m_afLodDistances[0] * m_afLodDistances[0];
	demo.m_afSquaredLodDistances[1] = m_afLodDistances[1] * m_afLodDistances[1];
	
	
	demo.m_load3dModelIndex    &= ~(1<<2);;

}


/*!****************************************************************************
 @Function		InitApplication
 @Return		bool		true if no error occured
 @Description	Code in InitApplication() will be called by PVRShell once per
				run, before the rendering context is created.
				Used to initialize variables that are not dependant on it
				(e.g. external modules, loading meshes, etc.)
				If the rendering context is lost, InitApplication() will
				not be called again.
//******************************************************************************/
//bool OglES2Navigation3D::InitApplication()
WebglNavigation3DSim.prototype.initApplication = function(PVRShell)
{

    this.modelShadow = new PVRModelShadow();

	for (let i = 0 ; i< NUM_STATES; i++){
		m_Buttons[i] = new PVRTBoundingBox2D();
		m_ButtonCoordinates[i] = [ new PVRVector2(),new PVRVector2(),new PVRVector2(),new PVRVector2() ];
		m_ButtonTexCoords[i] = [ new PVRVector2(),new PVRVector2(),new PVRVector2(),new PVRVector2() ];
	}

	this.isreadyRenderingUI = false;

	this.m_uiTextureIdUI = {};
	this.m_uiTextureIdSkybox = {};


this.completeVBO = 0;


	this.ulPreviousTime = PVRShell.getTimeNow();
	this.ulLastUpdate = PVRShell.getTimeNow();

	this.loading_finished = false
	// this.m_CameraPod = new PVRModel();  //CPVRTModelPOD
	this.m_fFOV = 0.0;
	this.m_fAspectRatio =0.0;
	this.m_fNearClipPlane = 0.0;
	this.m_fFarClipPlane = 0.0;
	//m_afLodDistances = new Float32Array(2)     ;
	this.m_afSquaredLodDistances = new Float32Array(2)     ;


	this.m_paPVRTCityBlocks = [];
	//this.m_pauiVisibleTiles = [];
	this.m_paPVRTOcclusionData = null;
	this.m_CameraPod = {};

	m_abStates[STATE_PAUSE] = false;
	m_abStates[STATE_SHADOW] = true;
	m_abStates[STATE_DEBUG] = false;
	m_abStates[STATE_CULLING] = true;
	m_abStates[STATE_OCCLUSION] = true;
	m_abStates[STATE_INPUT_MODE] = true;
	m_abStates[STATE_UI] = false;

	this.m_ppaShadowMesh = [];
	this.m_ppaShadowVol = [];
	this.m_ppaShadowRenderID = [];
	this.m_ppaVolumeScale = [];

	m_uiNumTextures = 0;
	this.m_uiNumPVRTCityBlocks = 0;
	m_uiNumVisibleTiles = 0;
	this.m_uiNumOcclusionData = 0;

	m_uiNumTextures =  c_paszTextures.length; ///sizeof(c_paszTextures[0]);
	this.m_pauiTextureIds = new Array(m_uiNumTextures);  //gluint

	m_vMousePrevPos = new PVRVector2(-1.0, -1.0);
	m_mMouseLookMatrix =  PVRMatrix4x4.identity();  
	m_mMouseLightMatrix = PVRMatrix4x4.identity();

	// // Get and set the read path for content files
	// CPVRTResourceFile::SetReadPath((char*)PVRShellGet(prefReadPath));

	// // Get and set the load/release functions for loading external files.
	// // In the majority of cases the PVRShell will return NULL function pointers implying that
	// // nothing special is required to load external files.
	// CPVRTResourceFile::SetLoadReleaseFunctions(PVRShellGet(prefLoadFileFunc), PVRShellGet(prefReleaseFileFunc));


	for (let i = 0 ; i < 3; ++i)
	{
		this.m_load3dModelIndex |= (1<<i);
	}

	//for (let i=0; i <  m_uiNumTextures+2; ++i) {
		this.LoadingTextures = 2 + m_uiNumTextures;
	//}

	if (!this.load3dModelIndex(c_szModelIndexFilename))
	{
		//console.log("error in loading 3dModels");
		return false;
	}


	if (!this.loadOcclusionData(c_szOcclusionDataFilename))
	{
		//console.log("error in loading occulation");
		return false;
	}




	// if (PVR_SUCCESS != m_CameraPod.ReadFromFile("cameratrack.pod"))
	// {
	// 	PVRShellSet(prefExitMessage, "Error: Failed to parse POD cameratrack.\n");
	// 	return false;
	// }
	
	

  

(function(demo)
	{
		 let fs = new PVRFileStream();
		 fs.Open(c_szTrackFile, true, loadPOD, demo);
	})(this);

	
	m_vLightDirection =  new  PVRVector3(0.1, 0.1, -1.0);
	m_vLightDirection.normalise();
	//PVRShellSet(prefStencilBufferContext, true);
	  // Set timer variables
	  m_fCameraAnimation = 0.0;
  
	  return true;
  }
  
/*!****************************************************************************
 @Function		QuitApplication
 @Return		bool		true if no error occured
 @Description	Code in QuitApplication() will be called by PVRShell once per
				run, just before exiting the program.
				If the rendering context is lost, QuitApplication() will
				not be called.
******************************************************************************/
//bool OglES2Navigation3D::quitApplication()
WebglNavigation3DSim.prototype.quitApplication = function()
{
	this.release3dModelIndex();
	this.releaseOcclusionData();

	this.m_pauiTextureIds = null;
	this.m_pauiVisibleTiles = null;

//	this.releaseShadowVolumes();

    return true;
}



	
/*!****************************************************************************
 @Function		InitView
 @Return		bool		true if no error occured
 @Description	Code in InitView() will be called by PVRShell upon
				initialization or after a change in the rendering context.
				Used to initialize variables that are dependant on the rendering
				context (e.g. textures, vertex buffers, etc.)
******************************************************************************/
//bool OglES2Navigation3D::InitView()
WebglNavigation3DSim.prototype.initView = function(gl, PVRShell)
{
	

	this.m_fAspectRatio = PVRShell.data.width/ PVRShell.data.height //PVRShellGet(prefWidth) / (float)PVRShellGet(prefHeight);

	

	// Load and compile the shaders & link programs
	if (!this.loadShaders(gl))
	{
		//PVRShellSet(prefExitMessage, ErrorStr.c_str());
		return false;
	}

	// Load textures
	if (!this.loadTextures(gl))
	{//
		//PVRShellSet(prefExitMessage, ErrorStr.c_str());
		return false;
	}

	// Is the screen rotated?
//	m_bRotate = PVRShellGet(prefIsRotated) && PVRShellGet(prefFullScreen);

	// Initialize Print3D
	//if(
	//	m_Print3D.SetTextures(0,PVRShellGet(prefWidth),PVRShellGet(prefHeight));  //, m_bRotate) != PVR_SUCCESS)
	
	m_Print3D.setTextures(gl, PVRShell.data.width, PVRShell.data.height)

		// {
	// 	PVRShellSet(prefExitMessage, "ERROR: Cannot initialise Print3D\n");
	// 	return false;
	// }

	// Generate the skybox VBO
	//glfloat *pSkyboxVertices, *pSkyboxTexCoords;

	//PVRTCreateSkybox(10.0f, true, 512, &pSkyboxVertices, &pSkyboxTexCoords);
	
 // Create the skybox
   // let data = new PVRSkybox(10.0, true, 512);
   let data = new PVRSkybox(10.0, true, 512);	
   this.SkyboxVertices  = data;

	m_uiSkyboxVBO = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, m_uiSkyboxVBO);
   //	gl.bufferData(gl.ARRAY_BUFFER, sizeof(glfloat)*3*24, pSkyboxVertices, gl.STATIC_DRAW);
   //   gl.bufferData(gl.ARRAY_BUFFER, 4*3*24, pSkyboxVertices, gl.STATIC_DRAW);

gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(this.SkyboxVertices), gl.STATIC_DRAW);


gl.bindBuffer(gl.ARRAY_BUFFER,null)
	//PVRTDestroySkybox(pSkyboxVertices, pSkyboxTexCoords);

	this.initUI(gl);

	// No stencil test required
	gl.disable(gl.STENCIL_TEST);

	// Disable blending by default
	gl.disable(gl.BLEND);

	// Paint it black
	gl.clearColor(0.0, 0.0, 0.0, 1.0);

	// Texture channel 0 will always be active
	gl.activeTexture(gl.TEXTURE0);

	// Setup the viewport for the whole window
	gl.viewport(0,0, PVRShell.data.width, PVRShell.data.height);
	//gl.viewport(0, 0, PVRShellGet(prefWidth), PVRShellGet(prefHeight));

	m_ui32InitState = 0;
	m_ui32TextureBase = 0;
	m_ui32BlockBase = 0;

	//console.log("loading Views");
	return true;
}

/*!****************************************************************************
 @Function		ReleaseShader
 @Return		bool		true if no error occured
 @Description	Releases a shader program including the individual shader objects.
******************************************************************************/
//bool OglES2Navigation3D::ReleaseShader(Shader &shader)
WebglNavigation3DSim.prototype.releaseShader = function(gl, shader)

{
	gl.deleteProgram(shader.uiId);
	gl.deleteShader(shader.uiVertexShaderId);
	gl.deleteShader(shader.uiFragmentShaderId);
	return true;
}

/*!****************************************************************************
 @Function		ReleaseView
 @Return		bool		true if no error occured
 @Description	Code in ReleaseView() will be called by PVRShell when the
				application quits or before a change in the rendering context.
******************************************************************************/
//bool OglES2Navigation3D::ReleaseView()
WebglNavigation3DSim.prototype.releaseView = function(gl)
{
	// Delete textures
	gl.deleteTextures(1, this.m_uiTextureIdSkybox);
	gl.deleteTextures(m_uiNumTextures, this.m_pauiTextureIds);

	// Delete program and shader objects
	this.releaseShader(gl,m_CityEntityShader);
	this.releaseShader(gl,m_SkyboxShader);
	this.releaseShader(gl,m_ShadowVolShader);
	this.releaseShader(gl,m_FullscreenShader);


	this.releaseShader(gl,m_UIShader);
	gl.deleteTextures(1, this.m_uiTextureIdUI);


	gl.deleteBuffers(1, m_uiSkyboxVBO);

	// Release Print3D Textures
	//m_Print3D.releaseTextures();

	return true;
}

/*!****************************************************************************
 @Function		RenderScene
 @Return		bool		true if no error occured
 @Description	Main rendering loop function of the program. The shell will
				call this function every frame.
				egl.SwapBuffers() will be performed by PVRShell automatically.
				PVRShell will also manage important OS events.
				The user has access to these events through an abstraction
				layer provided by PVRShell.
******************************************************************************/
//bool OglES2Navigation3D::RenderScene()


WebglNavigation3DSim.prototype.renderScene = function(gl, PVRShell)
{
	//PVRShellOutputDebug("Nav3D: RenderScene() enter\n");
	// Return early as long as we are not finished loading the assets
	
	if (this.m_load3dModelIndex)
	{
		return true; //Wait for texture loading
	}

	if (this.loadAssets(gl))  return true;
	
	//if (this.loading_finished) return true;

	
	if (this.LoadingTextures > 0)
		{
			////console.log("loading Texture", this.LoadingTextures);
			return true; //Wait for texture loading
		}

		
	
	// Handle user input and update the timer based variables
	this.handleInput(PVRShell);
	this.updateTimer(PVRShell);
	
	// Update the camera interpolation and extract required matrices
	this.calculateCameraMatrices();
	this.calculateLightMatrices();

	// Clear the colour, depth and stencil buffer
	gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);

	// Disable depth test to render the skybox
	gl.disable(gl.CULL_FACE);
	gl.disable(gl.DEPTH_TEST);
	
	this.renderSkyBox(gl);

	// Enable depth test and render city blocks
	gl.enable(gl.DEPTH_TEST);
	gl.enable(gl.CULL_FACE);

	if (m_abStates[STATE_OCCLUSION] )
	{
		
		// Render using occlusion information
		this.render3dModelsOcclusion(gl);
	}
	else
	{
		
		// Render using visibility information
		this.render3dModelsVisibilitySet(gl);
	}

	// Render shadows
	if (m_abStates[STATE_SHADOW])
	{
		// if the lightsource moved recreate the shadow volumes
		if (m_bUpdateShadowData)
		{
			this.updateShadowVolumes(gl);
			m_bUpdateShadowData = false;
		}
		// finally render them
		this.renderShadowVolumes(gl);
	}

//#ifdef ENABLE_UI
	// Render UI on top of the 3D scene
if (this.isreadyRenderingUI) {	this.renderUI(gl);}

//#endif
	// Displays the demo name and other information using the Print3D tool.
	// For a detailed explanation, see the training course IntroducingPVRTools
	m_Print3D.displayDefaultTitle("3D Navigation", null, EPVRPrint3D.Logo.PowerVR);
//	#if defined(ENABLE_ADVANCED_OUTPUT) && !defined(ENABLE_UI)
//	m_Print3D.Print3D(0.5f, 94.0f, 0.5f, 0xFFFFFFFF, "Shadows %s  %s", (m_abStates[STATE_SHADOW] ? "enabled" : "disabled"), (m_abStates[STATE_DEBUG] ? "(debug)" : ""));
//	m_Print3D.Print3D(0.5f, 97.0f, 0.5f, 0xFFFFFFFF, "Culling - Occlusion: %s  Frustum: %s", (m_abState[STATE_OCCLUSION] ? "On" : "Off"), (m_abStates[STATE_CULLING] ? "On" : "Off"));
//    #endif
	m_Print3D.flush(gl);

	return true;
}

//#ifdef ENABLE_UI
/*!****************************************************************************
 @Function		RenderUI
 @Description	Renders an alpha-blended UI consisting of simple buttons.
******************************************************************************/
//void OglES2Navigation3D::RenderUI()
WebglNavigation3DSim.prototype.renderUI = function(gl)
{

	if (m_abStates[STATE_UI])
	{
		let rotMatrix = PVRMatrix3x3.identity();
		if (m_bRotate) rotMatrix = PVRMatrix3x3.createRotationZ3D( - PVRMaths.PI/2.0)  ; // :: Rotation2D(-PVRT_PI_OVER_TWO);
		let matrix = [ rotMatrix.data[0], rotMatrix.data[1], rotMatrix.data[3], rotMatrix.data[4] ];


		//new ArrayBuffer(6);
		//  indices[0]=0;
		//  indices[1]=1;
		//  indices[2]=2;
		//  indices[3]=0;
		//  indices[4]=2;
		//  indices[5]=3;

//		//console.log("Uint8Array", new Uint8Array( indices));
//		//console.log("array buffer", new ArrayBuffer( indices));


		gl.disable(gl.CULL_FACE);
		gl.disable(gl.DEPTH_TEST);
		gl.enable(gl.BLEND);
		gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

		gl.useProgram(m_UIShader.uiId);
		gl.uniformMatrix2fv(m_UIShader.uiRoationMatrixLoc, false, matrix);

		gl.activeTexture(gl.TEXTURE0);
	
		gl.bindTexture(gl.TEXTURE_2D, this.m_uiTextureIdUI);
		
		let  afVertexData6 = [ m_ButtonCoordinates[STATE_PAUSE][0].data[0], m_ButtonCoordinates[STATE_PAUSE][0].data[1], 	m_ButtonTexCoords[STATE_PAUSE][0].data[0],	m_ButtonTexCoords[STATE_PAUSE][0].data[1],
		m_ButtonCoordinates[STATE_PAUSE][1].data[0], m_ButtonCoordinates[STATE_PAUSE][1].data[1], 	m_ButtonTexCoords[STATE_PAUSE][1].data[0],	m_ButtonTexCoords[STATE_PAUSE][1].data[1],
		m_ButtonCoordinates[STATE_PAUSE][2].data[0], m_ButtonCoordinates[STATE_PAUSE][2].data[1], 	m_ButtonTexCoords[STATE_PAUSE][2].data[0],	m_ButtonTexCoords[STATE_PAUSE][2].data[1],
		m_ButtonCoordinates[STATE_PAUSE][3].data[0], m_ButtonCoordinates[STATE_PAUSE][3].data[1], 	m_ButtonTexCoords[STATE_PAUSE][3].data[0],	m_ButtonTexCoords[STATE_PAUSE][3].data[1]]
	 





		gl.enableVertexAttribArray(VERTEX_ARRAY_UI);
		gl.enableVertexAttribArray(TEXCOORD_ARRAY_UI);




		if(!this.UiIDs) {this.UiIDs = gl.createBuffer();
	
		}
			
	  
	  // gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData6) , gl.DYNAMIC_DRAW);
   
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.UiIDs);
	//	gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint8Array( indices), gl.DYNAMIC_DRAW); 
		//	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
		//}
	
			
		// //console.log("size1",gl.getBufferParameter(gl.ARRAY_BUFFER, gl.BUFFER_SIZE));
	
		// //console.log("usage1",gl.getBufferParameter(gl.ARRAY_BUFFER, gl.BUFFER_USAGE));	
		// //console.log("size2",gl.getBufferParameter(gl.ELEMENT_ARRAY_BUFFER, gl.BUFFER_SIZE));	
		// //console.log("usage2",gl.getBufferParameter(gl.ELEMENT_ARRAY_BUFFER, gl.BUFFER_USAGE));	
	
			//gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
	// 	}
	// else{
	// 	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.UiIDs);	   
	// }
	
	  


	
	

		var address = 0;
		for (let i=0; i <  NUM_STATES; i++)
		{
			


			switch(i)
			{
			case STATE_PAUSE:
			case STATE_SHADOW:
			case STATE_DEBUG:
			case STATE_CULLING:
			case STATE_OCCLUSION:
				{
 
 gl.bindBuffer(gl.ARRAY_BUFFER, this.UiArrayIDs[i]);
 //gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.UiIDs);
	
			//		let location = PVRVector2.scalarMultiply( new PVRVector2(m_Buttons[i].minCoords.data[0] - 0.5, 0.5 - m_Buttons[i].minCoords.data[1]) , 2.0);
				//	//console.log("m_ButtonCoordinates[i]",m_ButtonCoordinates[i][0].data[1]);
			//	//console.log("m_ButtonCoordinates[STATE_OCCLUSION]", m_ButtonCoordinates[STATE_OCCLUSION][0].data[0]);
					//	gl.vertexAttribPointer(VERTEX_ARRAY_UI, 2, gl.FLOAT, gl.FALSE, sizeof(new PVRVector2), m_ButtonCoordinates[i][0].ptr());
				//	gl.vertexAttribPointer(TEXCOORD_ARRAY_UI, 2, gl.FLOAT, gl.FALSE, sizeof(new PVRVector2), m_ButtonTexCoords[i][0].ptr());
			
				    gl.vertexAttribPointer(VERTEX_ARRAY_UI, 2, gl.FLOAT, false, 16, 0);
					gl.vertexAttribPointer(TEXCOORD_ARRAY_UI, 2, gl.FLOAT, false, 16, 8);
					//address += 16;
					if (m_abStates[i])
						gl.uniform4f(m_UIShader.uiColourScaleLoc, 1.0, 1.0, 1.0, 1.0);
					else
						gl.uniform4f(m_UIShader.uiColourScaleLoc, 0.8, 0.8, 0.8, 0.4);
		
					
			
				gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT,0);
					   


					break;
				}
			case STATE_INPUT_MODE:
				{
					
			  gl.bindBuffer(gl.ARRAY_BUFFER, this.UiArrayIDs[i]);
					if (m_abStates[STATE_PAUSE])
					{
						gl.uniform4f(m_UIShader.uiColourScaleLoc, 1.0, 1.0, 1.0, 1.0);

					//	gl.vertexAttribPointer(VERTEX_ARRAY_UI, 2, gl.FLOAT, gl.FALSE, sizeof(new PVRVector2), m_ButtonCoordinates[i][0].ptr());
					gl.vertexAttribPointer(VERTEX_ARRAY_UI, 2, gl.FLOAT, gl.FALSE, 24, 0);
							
						
						if (m_abStates[STATE_INPUT_MODE])
							//gl.vertexAttribPointer(TEXCOORD_ARRAY_UI, 2, gl.FLOAT, gl.FALSE, sizeof(new PVRVector2), m_ButtonTexCoords[i][0].ptr());
							gl.vertexAttribPointer(TEXCOORD_ARRAY_UI, 2, gl.FLOAT, gl.FALSE, 24, 8);
						else
						//	gl.vertexAttribPointer(TEXCOORD_ARRAY_UI, 2, gl.FLOAT, gl.FALSE, sizeof(new PVRVector2), m_ButtonTexCoords[i+1][0].ptr());
						gl.vertexAttribPointer(TEXCOORD_ARRAY_UI, 2, gl.FLOAT, gl.FALSE, 24,16);
						//gl.drawElements(gl.TRIANGLES, indexdatabucket.numIndices, gl.UNSIGNED_SHORT, 0);	
						gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
						//gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, indices);
					}
					break;
				}
			default:
				break;
			}
		}

		gl.disableVertexAttribArray(VERTEX_ARRAY_UI);
		gl.disableVertexAttribArray(TEXCOORD_ARRAY_UI);
		gl.enable(gl.DEPTH_TEST);
		gl.disable(gl.BLEND);
		gl.enable(gl.CULL_FACE);
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
		gl.bindBuffer(gl.ARRAY_BUFFER, null);
		
	}
}

/*!****************************************************************************
 @Function		InitUI
 @Description	Sets up all button locations and rendering attributes.
******************************************************************************/
//void OglES2Navigation3D::InitUI()
WebglNavigation3DSim.prototype.initUI = function(gl)
{
	let indices = [0,1,2,0,2,3]	;
	if(!this.UiIDs) {this.UiIDs = gl.createBuffer();
	
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.UiIDs);
	gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, (new Uint16Array( indices)), gl.STATIC_DRAW); 
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }




	let offset = new PVRVector2(-1.0, -1.0);
	let buttonsize = new PVRVector2(0.3, 0.2);
	this.UiArrayIDs = new Array(NUM_STATES);

	

	// Pause button - upper right corner
	m_Buttons[STATE_PAUSE].minCoords = new PVRVector2(0.7, 0.2);
	m_Buttons[STATE_PAUSE].maxCoords =  PVRVector2.add (m_Buttons[STATE_PAUSE].minCoords , buttonsize) 
	m_ButtonCoordinates[STATE_PAUSE][0] = PVRVector2.add (PVRVector2.scalarMultiply( new PVRVector2(m_Buttons[STATE_PAUSE].minCoords.data[0], 1.0 - m_Buttons[STATE_PAUSE].minCoords.data[1]),  2.0) , offset);
	m_ButtonCoordinates[STATE_PAUSE][1] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_PAUSE].maxCoords.data[0], 1.0 - m_Buttons[STATE_PAUSE].minCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_PAUSE][2] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_PAUSE].maxCoords.data[0], 1.0 - m_Buttons[STATE_PAUSE].maxCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_PAUSE][3] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_PAUSE].minCoords.data[0], 1.0 - m_Buttons[STATE_PAUSE].maxCoords.data[1]) , 2.0) ,  offset);
	m_ButtonTexCoords[STATE_PAUSE][0] = new PVRVector2(0.0, 0.25);
	m_ButtonTexCoords[STATE_PAUSE][1] = new PVRVector2(0.5, 0.25);
	m_ButtonTexCoords[STATE_PAUSE][2] = new PVRVector2(0.5, 0.0);
	m_ButtonTexCoords[STATE_PAUSE][3] = new PVRVector2(0.0, 0.0);

	//let  afVertexData6 = [0.0,0.0,0.0,0.0,0.0,1.0,0.0,1.0,1.0,1.0,1.0,1.0,0.0,1.0,0.0,1.0  ];
	 let  afVertexData6 = [ m_ButtonCoordinates[STATE_PAUSE][0].data[0], m_ButtonCoordinates[STATE_PAUSE][0].data[1], 	m_ButtonTexCoords[STATE_PAUSE][0].data[0],	m_ButtonTexCoords[STATE_PAUSE][0].data[1],
	 m_ButtonCoordinates[STATE_PAUSE][1].data[0], m_ButtonCoordinates[STATE_PAUSE][1].data[1], 	m_ButtonTexCoords[STATE_PAUSE][1].data[0],	m_ButtonTexCoords[STATE_PAUSE][1].data[1],
	 m_ButtonCoordinates[STATE_PAUSE][2].data[0], m_ButtonCoordinates[STATE_PAUSE][2].data[1], 	m_ButtonTexCoords[STATE_PAUSE][2].data[0],	m_ButtonTexCoords[STATE_PAUSE][2].data[1],
	 m_ButtonCoordinates[STATE_PAUSE][3].data[0], m_ButtonCoordinates[STATE_PAUSE][3].data[1], 	m_ButtonTexCoords[STATE_PAUSE][3].data[0],	m_ButtonTexCoords[STATE_PAUSE][3].data[1]]
	
	


// let  verticeslength = 4;
// 	 const buffer = new ArrayBuffer(16 * verticeslength);
// //Fill array buffer
// const dv = new DataView(buffer);
// for (let i = 0; i < verticeslength; i++) {
//   dv.setFloat32(4 * i, m_ButtonCoordinates[STATE_PAUSE][i].data[0], true);
//   dv.setFloat32(4 * i + 4, m_ButtonCoordinates[STATE_PAUSE][i].data[1], true);
//   dv.setFloat32(4 * i + 8, m_ButtonTexCoords[STATE_PAUSE][i].data[0], true);
//   dv.setFloat32(4 * i + 12, m_ButtonTexCoords[STATE_PAUSE][i].data[1], true);
// }
	
	

	
	this.UiArrayIDs[STATE_PAUSE] = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, this.UiArrayIDs[STATE_PAUSE]);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData6) , gl.STATIC_DRAW);


	// Input button - middle right
	m_Buttons[STATE_INPUT_MODE].minCoords = new PVRVector2(0.7, 0.6);
	m_Buttons[STATE_INPUT_MODE].maxCoords =  PVRVector2.add (m_Buttons[STATE_INPUT_MODE].minCoords , buttonsize)
	
	m_ButtonCoordinates[STATE_INPUT_MODE][0] = PVRVector2.add (PVRVector2.scalarMultiply( new PVRVector2(m_Buttons[STATE_INPUT_MODE].minCoords.data[0], 1.0 - m_Buttons[STATE_INPUT_MODE].minCoords.data[1]),  2.0) , offset);
	m_ButtonCoordinates[STATE_INPUT_MODE][1] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_INPUT_MODE].maxCoords.data[0], 1.0 - m_Buttons[STATE_INPUT_MODE].minCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_INPUT_MODE][2] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_INPUT_MODE].maxCoords.data[0], 1.0 - m_Buttons[STATE_INPUT_MODE].maxCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_INPUT_MODE][3] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_INPUT_MODE].minCoords.data[0], 1.0 - m_Buttons[STATE_INPUT_MODE].maxCoords.data[1]) , 2.0) ,  offset);

	m_ButtonTexCoords[STATE_INPUT_MODE][0] = new PVRVector2(0.5, 1.0);
	m_ButtonTexCoords[STATE_INPUT_MODE][1] = new PVRVector2(1.0, 1.0);
	m_ButtonTexCoords[STATE_INPUT_MODE][2] = new PVRVector2(1.0, 0.75);
	m_ButtonTexCoords[STATE_INPUT_MODE][3] = new PVRVector2(0.5, 0.75);

	m_ButtonTexCoords[STATE_INPUT_MODE+1][0] = new PVRVector2(0.5, 0.75);
	m_ButtonTexCoords[STATE_INPUT_MODE+1][1] = new PVRVector2(1.0, 0.75);
	m_ButtonTexCoords[STATE_INPUT_MODE+1][2] = new PVRVector2(1.0, 0.5);
	m_ButtonTexCoords[STATE_INPUT_MODE+1][3] = new PVRVector2(0.5, 0.5);
	
	let  afVertexData5 = [ m_ButtonCoordinates[STATE_INPUT_MODE][0].data[0], m_ButtonCoordinates[STATE_INPUT_MODE][0].data[1], 	m_ButtonTexCoords[STATE_INPUT_MODE][0].data[0],	m_ButtonTexCoords[STATE_INPUT_MODE][0].data[1],	m_ButtonTexCoords[STATE_INPUT_MODE+1][0].data[0],	m_ButtonTexCoords[STATE_INPUT_MODE+1][0].data[1],
	m_ButtonCoordinates[STATE_INPUT_MODE][1].data[0], m_ButtonCoordinates[STATE_INPUT_MODE][1].data[1], 	m_ButtonTexCoords[STATE_INPUT_MODE][1].data[0],	m_ButtonTexCoords[STATE_INPUT_MODE][1].data[1],m_ButtonTexCoords[STATE_INPUT_MODE+1][1].data[0],	m_ButtonTexCoords[STATE_INPUT_MODE+1][1].data[1],
	m_ButtonCoordinates[STATE_INPUT_MODE][2].data[0], m_ButtonCoordinates[STATE_INPUT_MODE][2].data[1], 	m_ButtonTexCoords[STATE_INPUT_MODE][2].data[0],	m_ButtonTexCoords[STATE_INPUT_MODE][2].data[1],m_ButtonTexCoords[STATE_INPUT_MODE+1][2].data[0],	m_ButtonTexCoords[STATE_INPUT_MODE+1][2].data[1],
	m_ButtonCoordinates[STATE_INPUT_MODE][3].data[0], m_ButtonCoordinates[STATE_INPUT_MODE][3].data[1], 	m_ButtonTexCoords[STATE_INPUT_MODE][3].data[0],	m_ButtonTexCoords[STATE_INPUT_MODE][3].data[1],m_ButtonTexCoords[STATE_INPUT_MODE+1][3].data[0],	m_ButtonTexCoords[STATE_INPUT_MODE+1][3].data[1],]
	
	
	
	
	
	this.UiArrayIDs[STATE_INPUT_MODE] = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, this.UiArrayIDs[STATE_INPUT_MODE]);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData5) , gl.STATIC_DRAW);







 


	// Shadow button - upper left corner
	m_Buttons[STATE_SHADOW].minCoords = new PVRVector2(0.0, 0.1);
	m_Buttons[STATE_SHADOW].maxCoords = PVRVector2.add (m_Buttons[STATE_SHADOW].minCoords , buttonsize)

	m_ButtonCoordinates[STATE_SHADOW][0] = PVRVector2.add (PVRVector2.scalarMultiply( new PVRVector2(m_Buttons[STATE_SHADOW].minCoords.data[0], 1.0 - m_Buttons[STATE_SHADOW].minCoords.data[1]),  2.0) , offset);
	m_ButtonCoordinates[STATE_SHADOW][1] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_SHADOW].maxCoords.data[0], 1.0 - m_Buttons[STATE_SHADOW].minCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_SHADOW][2] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_SHADOW].maxCoords.data[0], 1.0 - m_Buttons[STATE_SHADOW].maxCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_SHADOW][3] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_SHADOW].minCoords.data[0], 1.0 - m_Buttons[STATE_SHADOW].maxCoords.data[1]) , 2.0) ,  offset);

	
	m_ButtonTexCoords[STATE_SHADOW][0] = new PVRVector2(0.0, 0.75);
	m_ButtonTexCoords[STATE_SHADOW][1] = new PVRVector2(0.5, 0.75);
	m_ButtonTexCoords[STATE_SHADOW][2] = new PVRVector2(0.5, 0.5);
	m_ButtonTexCoords[STATE_SHADOW][3] = new PVRVector2(0.0, 0.5);


	let  afVertexData4 = [ m_ButtonCoordinates[STATE_SHADOW][0].data[0], m_ButtonCoordinates[STATE_SHADOW][0].data[1], 	m_ButtonTexCoords[STATE_SHADOW][0].data[0],	m_ButtonTexCoords[STATE_SHADOW][0].data[1],
	m_ButtonCoordinates[STATE_SHADOW][1].data[0], m_ButtonCoordinates[STATE_SHADOW][1].data[1], 	m_ButtonTexCoords[STATE_SHADOW][1].data[0],	m_ButtonTexCoords[STATE_SHADOW][1].data[1],
	m_ButtonCoordinates[STATE_SHADOW][2].data[0], m_ButtonCoordinates[STATE_SHADOW][2].data[1], 	m_ButtonTexCoords[STATE_SHADOW][2].data[0],	m_ButtonTexCoords[STATE_SHADOW][2].data[1],
	m_ButtonCoordinates[STATE_SHADOW][3].data[0], m_ButtonCoordinates[STATE_SHADOW][3].data[1], 	m_ButtonTexCoords[STATE_SHADOW][3].data[0],	m_ButtonTexCoords[STATE_SHADOW][3].data[1]]
	
	this.UiArrayIDs[STATE_SHADOW] = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, this.UiArrayIDs[STATE_SHADOW]);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData4) , gl.STATIC_DRAW);
	

	// Debug button - lower left corner
	m_Buttons[STATE_DEBUG].minCoords = new PVRVector2(0.0, 0.7);


	m_Buttons[STATE_DEBUG].maxCoords = PVRVector2.add (m_Buttons[STATE_DEBUG].minCoords , buttonsize)

	m_ButtonCoordinates[STATE_DEBUG][0] = PVRVector2.add (PVRVector2.scalarMultiply( new PVRVector2(m_Buttons[STATE_DEBUG].minCoords.data[0], 1.0 - m_Buttons[STATE_DEBUG].minCoords.data[1]),  2.0) , offset);
	m_ButtonCoordinates[STATE_DEBUG][1] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_DEBUG].maxCoords.data[0], 1.0 - m_Buttons[STATE_DEBUG].minCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_DEBUG][2] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_DEBUG].maxCoords.data[0], 1.0 - m_Buttons[STATE_DEBUG].maxCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_DEBUG][3] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_DEBUG].minCoords.data[0], 1.0 - m_Buttons[STATE_DEBUG].maxCoords.data[1]) , 2.0) ,  offset);

	
	m_ButtonTexCoords[STATE_DEBUG][0] = new PVRVector2(0.5, 0.5);
	m_ButtonTexCoords[STATE_DEBUG][1] = new PVRVector2(1.0, 0.5);
	m_ButtonTexCoords[STATE_DEBUG][2] = new PVRVector2(1.0, 0.25);
	m_ButtonTexCoords[STATE_DEBUG][3] = new PVRVector2(0.5, 0.25);


	
	let  afVertexData3 = [ m_ButtonCoordinates[STATE_DEBUG][0].data[0], m_ButtonCoordinates[STATE_DEBUG][0].data[1], 	m_ButtonTexCoords[STATE_DEBUG][0].data[0],	m_ButtonTexCoords[STATE_DEBUG][0].data[1],
	m_ButtonCoordinates[STATE_DEBUG][1].data[0], m_ButtonCoordinates[STATE_DEBUG][1].data[1], 	m_ButtonTexCoords[STATE_DEBUG][1].data[0],	m_ButtonTexCoords[STATE_DEBUG][1].data[1],
	m_ButtonCoordinates[STATE_DEBUG][2].data[0], m_ButtonCoordinates[STATE_DEBUG][2].data[1], 	m_ButtonTexCoords[STATE_DEBUG][2].data[0],	m_ButtonTexCoords[STATE_DEBUG][2].data[1],
	m_ButtonCoordinates[STATE_DEBUG][3].data[0], m_ButtonCoordinates[STATE_DEBUG][3].data[1], 	m_ButtonTexCoords[STATE_DEBUG][3].data[0],	m_ButtonTexCoords[STATE_DEBUG][3].data[1]]
	this.UiArrayIDs[STATE_DEBUG] = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, this.UiArrayIDs[STATE_DEBUG]);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData3) , gl.STATIC_DRAW);
	

	// Culling button - upper middle left corner
	m_Buttons[STATE_CULLING].minCoords = new PVRVector2(0.0, 0.3);


	m_Buttons[STATE_CULLING].maxCoords = PVRVector2.add (m_Buttons[STATE_CULLING].minCoords , buttonsize)

	m_ButtonCoordinates[STATE_CULLING][0] = PVRVector2.add (PVRVector2.scalarMultiply( new PVRVector2(m_Buttons[STATE_CULLING].minCoords.data[0], 1.0 - m_Buttons[STATE_CULLING].minCoords.data[1]),  2.0) , offset);
	m_ButtonCoordinates[STATE_CULLING][1] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_CULLING].maxCoords.data[0], 1.0 - m_Buttons[STATE_CULLING].minCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_CULLING][2] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_CULLING].maxCoords.data[0], 1.0 - m_Buttons[STATE_CULLING].maxCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_CULLING][3] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_CULLING].minCoords.data[0], 1.0 - m_Buttons[STATE_CULLING].maxCoords.data[1]) , 2.0) ,  offset);


	
	m_ButtonTexCoords[STATE_CULLING][0] = new PVRVector2(0.0, 1.0);
	m_ButtonTexCoords[STATE_CULLING][1] = new PVRVector2(0.5, 1.0);
	m_ButtonTexCoords[STATE_CULLING][2] = new PVRVector2(0.5, 0.75);
	m_ButtonTexCoords[STATE_CULLING][3] = new PVRVector2(0.0, 0.75);

	
	let  afVertexData2 = [ m_ButtonCoordinates[STATE_CULLING][0].data[0], m_ButtonCoordinates[STATE_CULLING][0].data[1], 	m_ButtonTexCoords[STATE_CULLING][0].data[0],	m_ButtonTexCoords[STATE_CULLING][0].data[1],
	m_ButtonCoordinates[STATE_CULLING][1].data[0], m_ButtonCoordinates[STATE_CULLING][1].data[1], 	m_ButtonTexCoords[STATE_CULLING][1].data[0],	m_ButtonTexCoords[STATE_CULLING][1].data[1],
	m_ButtonCoordinates[STATE_CULLING][2].data[0], m_ButtonCoordinates[STATE_CULLING][2].data[1], 	m_ButtonTexCoords[STATE_CULLING][2].data[0],	m_ButtonTexCoords[STATE_CULLING][2].data[1],
	m_ButtonCoordinates[STATE_CULLING][3].data[0], m_ButtonCoordinates[STATE_CULLING][3].data[1], 	m_ButtonTexCoords[STATE_CULLING][3].data[0],	m_ButtonTexCoords[STATE_CULLING][3].data[1]]
	this.UiArrayIDs[STATE_CULLING] = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, this.UiArrayIDs[STATE_CULLING]);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData2) , gl.STATIC_DRAW);

	// Occlusion button - lower middle left corner
	m_Buttons[STATE_OCCLUSION].minCoords = new PVRVector2(0.0, 0.5);


	
	m_Buttons[STATE_OCCLUSION].maxCoords = PVRVector2.add (m_Buttons[STATE_OCCLUSION].minCoords ,  buttonsize)
	
	m_ButtonCoordinates[STATE_OCCLUSION][0] = PVRVector2.add (PVRVector2.scalarMultiply( new PVRVector2(m_Buttons[STATE_OCCLUSION].minCoords.data[0], 1.0 - m_Buttons[STATE_OCCLUSION].minCoords.data[1]),  2.0) , offset);
	m_ButtonCoordinates[STATE_OCCLUSION][1] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_OCCLUSION].maxCoords.data[0], 1.0 - m_Buttons[STATE_OCCLUSION].minCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_OCCLUSION][2] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_OCCLUSION].maxCoords.data[0], 1.0 - m_Buttons[STATE_OCCLUSION].maxCoords.data[1]) , 2.0) , offset);
	m_ButtonCoordinates[STATE_OCCLUSION][3] = PVRVector2.add (PVRVector2.scalarMultiply(new PVRVector2(m_Buttons[STATE_OCCLUSION].minCoords.data[0], 1.0 - m_Buttons[STATE_OCCLUSION].maxCoords.data[1]) , 2.0) ,  offset);


	m_ButtonTexCoords[STATE_OCCLUSION][0] = new PVRVector2(0.5, 0.25);
	m_ButtonTexCoords[STATE_OCCLUSION][1] = new PVRVector2(1.0, 0.25);
	m_ButtonTexCoords[STATE_OCCLUSION][2] = new PVRVector2(1.0, 0.0);
	m_ButtonTexCoords[STATE_OCCLUSION][3] = new PVRVector2(0.5, 0.0);




	let  afVertexData1 = [ m_ButtonCoordinates[STATE_OCCLUSION][0].data[0], m_ButtonCoordinates[STATE_OCCLUSION][0].data[1], 	m_ButtonTexCoords[STATE_OCCLUSION][0].data[0],	m_ButtonTexCoords[STATE_OCCLUSION][0].data[1],
	m_ButtonCoordinates[STATE_OCCLUSION][1].data[0], m_ButtonCoordinates[STATE_OCCLUSION][1].data[1], 	m_ButtonTexCoords[STATE_OCCLUSION][1].data[0],	m_ButtonTexCoords[STATE_OCCLUSION][1].data[1],
	m_ButtonCoordinates[STATE_OCCLUSION][2].data[0], m_ButtonCoordinates[STATE_OCCLUSION][2].data[1], 	m_ButtonTexCoords[STATE_OCCLUSION][2].data[0],	m_ButtonTexCoords[STATE_OCCLUSION][2].data[1],
	m_ButtonCoordinates[STATE_OCCLUSION][3].data[0], m_ButtonCoordinates[STATE_OCCLUSION][3].data[1], 	m_ButtonTexCoords[STATE_OCCLUSION][3].data[0],	m_ButtonTexCoords[STATE_OCCLUSION][3].data[1]]
	
	this.UiArrayIDs[STATE_OCCLUSION] = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, this.UiArrayIDs[STATE_OCCLUSION]);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData1) , gl.STATIC_DRAW);
	

	// Middle column
	m_Buttons[STATE_UI].minCoords = new PVRVector2(0.3, 0.0);
	m_Buttons[STATE_UI].maxCoords = new PVRVector2(0.7, 1.0);


	


	gl.bindBuffer(gl.ARRAY_BUFFER, null);

	this.isreadyRenderingUI = true

}
//#endif // ENABLE_UI


/*!****************************************************************************
 @Function		UpdateTimer
 @Input			none
 @Description	Updates the values of the current time, previous time, current time
				in seconds, delta time and the FPS counter used in the program
******************************************************************************/
//void OglES2Navigation3D::UpdateTimer()
WebglNavigation3DSim.prototype.updateTimer = function(PVRShell)
{
	

	let ulCurrentTime = PVRShell.getTimeNow();
	let ulTimeDelta = ulCurrentTime - this.ulPreviousTime;
	this.ulPreviousTime = ulCurrentTime;

	// Update the visible object four times per second
	if (ulCurrentTime - this.ulLastUpdate > 100)
	{
		this.ulLastUpdate = ulCurrentTime;
		if (!m_abStates[STATE_OCCLUSION])
			this.update3dModelWorkingset();
	}

	// Advance camera animation when not paused
	if (!m_abStates[STATE_PAUSE])
	{
		
		m_fCameraAnimation += ulTimeDelta * c_CameraMovementSpeedScale ;
		// Start from beginning when the end is near
		if (m_fCameraAnimation > (this.m_CameraPod.data.numFrames - 1))
		{
			m_fCameraAnimation = 0.0;
		
			// Jump to next camera track (if there are any)
			this.m_ActiveCameraTrack = (this.m_ActiveCameraTrack + 1) % this.m_CameraPod.data.numCameras;
		
		}
	}
}

/*!****************************************************************************
 @Function		Update3dModelWorkingset
 @Description	Updates the visible object set based on the camera view frustum.
******************************************************************************/
//void OglES2Navigation3D::Update3dModelWorkingset()
WebglNavigation3DSim.prototype.update3dModelWorkingset = function()
{
	
	let planes = [ new PVRVector4(),  new PVRVector4(),new PVRVector4(),new PVRVector4() ]  ;
	this.extractViewFrustumPlanes(m_mViewProjectionMatrixNonRotated, planes[0], planes[1], planes[2], planes[3]);
	const lodCenter = new PVRVector2(m_vCameraFrom.data[0], m_vCameraFrom.data[1]);

	// Start from scratch and assume that we don't see anything
	m_uiNumVisibleTiles = 0;

	// Update the object set for each layer
	for (let i=0; i< this.m_uiNumPVRTCityBlocks; i++)
	{
		let  bbox = this.m_paPVRTCityBlocks[i].boundingbox; //PVRTBoundingBox2D
		let culltest = this.boundingBoxIntersectsFrustum(bbox, planes);

		// If the tile intersects the viewfrustum:
		if (!(INTERSECT_NONE === culltest))
		{
			// Determine the LOD based on the distance to the camera position
			let distToCameraSquared = PVRVector2.length2( PVRVector2.subtract (  PVRVector2.scalarMultiply(   PVRVector2.add  (bbox.maxCoords, bbox.minCoords) , 0.5) , lodCenter))  ; //lenSqr();
			let  lod = (this.m_paPVRTCityBlocks[i].numLod - 1);

			// Iterate over all LODs starting from the last until the max. suitable LOD is found
			for (let j=0; j < this.m_paPVRTCityBlocks[i].numLod; j++)
			{
				if (distToCameraSquared < this.m_afSquaredLodDistances[j])
				{
					lod = j;
					break;
				}
			}

			// and add it to our list of visible tiles
			this.m_pauiVisibleTiles[m_uiNumVisibleTiles].tile = i;
			this.m_pauiVisibleTiles[m_uiNumVisibleTiles].lod = lod; //(unsigned short)
			this.m_pauiVisibleTiles[m_uiNumVisibleTiles].visibility = culltest; //(unsigned short)
			m_uiNumVisibleTiles++;
		}
	}

	// Fine grained culling within each tile: create a list of objects within the view frustum
	for (let i=0; i < m_uiNumVisibleTiles; i++)
	{
		let pLod = this.m_paPVRTCityBlocks[this.m_pauiVisibleTiles[i].tile].paLod[this.m_pauiVisibleTiles[i].lod]; //PVRTCityBlockLod *

		// Assume that we don't see any object within the tile
		pLod.numVisibleNodes = 0;

		// and create a list of objects which are within the viewfrustum (only needed if we
		// partially intersect the tile, add all objects otherwise)
		if (m_abStates[STATE_CULLING] && (this.m_pauiVisibleTiles[i].visibility === INTERSECT_PARTIAL))
		{
			// Check each node in each tile against the view frustum and add it to the list
			// of visible nodes if it is visible
			for (let j=0; j < pLod.numObjects; j++)
				if (this.boundingBoxIntersectsFrustum(pLod.paObjects[j].boundingbox, planes))
				{
					pLod.paVisibleNodes[pLod.numVisibleNodes] = j;
					pLod.numVisibleNodes += 1;
				}
		}
		else
			for (let j=0; j < pLod.numObjects; j++)
			{
				pLod.paVisibleNodes[pLod.numVisibleNodes] = j;
				pLod.numVisibleNodes+=1
			}
	}
}


/*!****************************************************************************
 @Function		HandleInput
 @Description	Handles user input.
******************************************************************************/
//void OglES2Navigation3D::HandleInput()
WebglNavigation3DSim.prototype.handleInput = function(PVRShell)
{
//#ifndef ENABLE_UI
	// Handle user input
	if (PVRShell.isKeyPressed(PVRShell.KeyNameDOWN))
	{
		m_abStates[STATE_PAUSE] = !m_abStates[STATE_PAUSE];
		m_mMouseLookMatrix = new PVRMatrix4x4.identity();
	}

	if (PVRShell.isKeyPressed(PVRShell.KeyNameUP)){
		
		this.m_ActiveCameraTrack = this.m_ActiveCameraTrack  % this.m_CameraPod.data.numCameras;  // nNumCamera;
	
	}
	if (PVRShell.isKeyPressed(PVRShell.KeyNameLEFT))
		m_abStates[STATE_CULLING] = !m_abStates[STATE_CULLING];

	if (PVRShell.isKeyPressed(PVRShell.KeyNameRIGHT))
	{
		m_abStates[STATE_OCCLUSION] = !m_abStates[STATE_OCCLUSION];
		if (!m_abStates[STATE_OCCLUSION])
			this.update3dModelWorkingset();
	}

	if (PVRShell.isKeyPressed(PVRShell.KeyNameACTION1))
		m_abStates[STATE_SHADOW] = !m_abStates[STATE_SHADOW];

	if (PVRShell.isKeyPressed(PVRShell.KeyNameACTION2))
		m_abStates[STATE_DEBUG] = !m_abStates[STATE_DEBUG];
//
//#else // ENABLE_UI

	let buttonState = PVRShell.getMouseButtonState();
	let pMousePtr = PVRShell.getPointerLocation() // Get(prefPointerLocation);
	

if (0 !== buttonState && null !== pMousePtr)
	{
	
			let mousePos = pMousePtr;

			if (!m_bMousePressed)
			{
				m_vMouseClickPos = mousePos;
				m_vMousePrevPos = mousePos;
				m_ulLastMouseClick = PVRShell.getTimeNow();//PVRShellGetTime();
			}

			let dragdir = PVRVector2.subtract( mousePos , m_vMousePrevPos);
			if (PVRVector2.length2(dragdir) > 0.0001) this.handleMouseDrag(dragdir);
			m_vMousePrevPos = mousePos;
			m_bMousePressed = true;
	}
	else
	{
		let curTime = PVRShell.getTimeNow();//PVRShellGetTime();

		if (m_bMousePressed)
		{
			let dist = PVRVector2.length2 ( PVRVector2.subtract( m_vMouseClickPos , m_vMousePrevPos));//.lenSqr();
			if ((dist < 0.001) && ((curTime - m_ulLastMouseClick) < 1000))	this.handleMouseClick(m_vMousePrevPos);
			m_bMousePressed = false;
		}
	}
//#endif // ENABLE_UI
}


/*!****************************************************************************
 @Function		HandleMouseClick
 @Description	Handles user input via mouse interactions.
******************************************************************************/
//void OglES2Navigation3D::HandleMouseClick(new PVRVector2 pos)
WebglNavigation3DSim.prototype.handleMouseClick = function(pos)
{
	// Just rotate the clicked position if the screen has been rotated so that the physical
	// and logical click position coincide.

	let rotMat = PVRMatrix3x3.identity();
	
	if (m_bRotate)
	{
		rotMat = PVRMatrix3x3.createRotationZ3D(- PVRMaths.PI / 2.0) ;
		let offsetPos = new PVRVector3(pos.data[0] - 0.5, pos.data[1] -0.5, 0.0);
	

		pos = new PVRVector2(  rotMat * offsetPos + new PVRVector3(0.5, 0.5, 0.0));
	}

//#ifdef ENABLE_UI
	if (WebglNavigation3DSim.PointInBoundingBox(pos, m_Buttons[STATE_UI])) m_abStates[STATE_UI] = !m_abStates[STATE_UI];

	// Only allow button clicks if they are actual visible
	if (m_abStates[STATE_UI])
	{
		for (let i=0; i < STATE_UI; i++)
		{
			if (WebglNavigation3DSim.PointInBoundingBox(pos, m_Buttons[i]))
			{
				m_abStates[i] = !m_abStates[i];

				// Reset to the camera path defined view direction when changing the pause state
				if (i === STATE_PAUSE)
					m_mMouseLookMatrix = new PVRMatrix4x4.identity();

				// Calculate the visibility set if view frustum visibility based culling should be used
				if (i === STATE_OCCLUSION && m_abStates[STATE_OCCLUSION] === false)
					this.update3dModelWorkingset();

				break;
			}
		}
	}
//#endif // ENABLE_UI


return pos


}


/*!****************************************************************************
 @Function		HandleMouseDrag
 @Description	Handles user input via mouse interactions.
******************************************************************************/
//void OglES2Navigation3D::HandleMouseDrag(new PVRVector2 dir)
WebglNavigation3DSim.prototype.handleMouseDrag = function(dir)
{

	if (m_abStates[STATE_PAUSE])
	{
		if (m_bRotate)
			dir = new PVRVector2(dir.data[1], dir.data[0]);

		if (m_abStates[STATE_INPUT_MODE])
		{
			dir = PVRVector2.scalarMultiply(dir,  c_UserCameraMovementSpeed);
			m_mMouseLookMatrix =  PVRMatrix4x4.multiply(m_mMouseLookMatrix,  PVRMatrix4x4.multiply( PVRMatrix4x4.createRotationZ3D(dir.data[0]),  PVRMatrix4x4.createRotationY3D(-dir.data[1])) )  //new PVRMatrix4x4.RotationZ(]) * new PVRMatrix4x4.RotationY(-dir.data[1]);
		}
		else
		{
			m_mMouseLightMatrix = PVRMatrix4x4.multiply(m_mMouseLookMatrix,  PVRMatrix4x4.multiply( PVRMatrix4x4.createRotationY3D(dir.data[0]),  PVRMatrix4x4.createRotationX3D(-dir.data[1])) )  
		 //new PVRMatrix4x4.RotationY(dir.data[0]) * new PVRMatrix4x4.RotationX(-dir.data[1]);
			m_bUpdateShadowData = true;
		}
	}
}


/*!****************************************************************************
 @Function		Render3dModelsVisibilitySet
 @Description	Renders the visible city blocks based on the view frustum
                intersection tests.
******************************************************************************/
//void OglES2Navigation3D::Render3dModelsVisibilitySet()
WebglNavigation3DSim.prototype.render3dModelsVisibilitySet = function(gl)
{
	let planes = [ new PVRVector4(), new PVRVector4(),new PVRVector4(),new PVRVector4()];
	this.extractViewFrustumPlanes(m_mViewProjectionMatrixNonRotated, planes[0], planes[1], planes[2], planes[3]);

	 let lightdir = m_vLightDirection;

	gl.useProgram(m_CityEntityShader.uiId);
	gl.uniformMatrix4fv(m_CityEntityShader.uiModelViewProjMatrixLoc,  gl.FALSE, m_mViewProjectionMatrix.data);
	gl.uniform3fv(m_CityEntityShader.uiLightDirectionLoc, lightdir.data);

	// Enable the vertex attribute arrays
	gl.enableVertexAttribArray(VERTEX_ARRAY);
	gl.enableVertexAttribArray(NORMAL_ARRAY);
	gl.enableVertexAttribArray(TEXCOORD_ARRAY);

	let prevTexture = {};

	for (let i=0; i <  m_uiNumVisibleTiles; i++)
	{
		const pLod = this.m_paPVRTCityBlocks[this.m_pauiVisibleTiles[i].tile].paLod[this.m_pauiVisibleTiles[i].lod];
		const tilevis = this.m_pauiVisibleTiles[i].visibility;
		if (!pLod.bLoaded)
			continue;

		gl.bindBuffer(gl.ARRAY_BUFFER, pLod.vbos[0]);
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, pLod.vbos[1]);

		let stride =  32; //sizeof(PVRTModelVertex);
		gl.vertexAttribPointer(VERTEX_ARRAY, 3, gl.FLOAT, gl.FALSE, stride, 0);
		gl.vertexAttribPointer(NORMAL_ARRAY, 3, gl.FLOAT, gl.FALSE, stride, 12);
		gl.vertexAttribPointer(TEXCOORD_ARRAY, 2, gl.FLOAT, gl.FALSE, stride, 24);//(const void*)STexCoordOffset);

		for (let j=0; j < pLod.numVisibleNodes; j++)
		{
			let  pObjectSet = pLod.paObjects[pLod.paVisibleNodes[j]]; //PVRTCityBlockEntity

			// Ignore the object if it is not visible
			if (m_abStates[STATE_CULLING] && (tilevis === INTERSECT_PARTIAL))
				if (!this.boundingBoxIntersectsFrustum(pObjectSet.boundingbox, planes))
					continue;

			for (let k=0; k < pObjectSet.numSubObjects; k++)
			{

				
				if (pObjectSet.pauiTextures[k] !== prevTexture)
				{
					  gl.activeTexture(gl.TEXTURE0);
					  gl.bindTexture(gl.TEXTURE_2D, pObjectSet.pauiTextures[k]);
					  prevTexture = pObjectSet.pauiTextures[k];
					
				}
					
				gl.drawElements(gl.TRIANGLES, pObjectSet.paNumIndices[k], gl.UNSIGNED_SHORT, pObjectSet.paIndexOffsets[k]*2);}
//(void *)(pObjectSet.paIndexOffsets[k]*sizeof(gl.ushort))

			
		}
	}

	gl.disableVertexAttribArray(VERTEX_ARRAY);
	gl.disableVertexAttribArray(NORMAL_ARRAY);
	gl.disableVertexAttribArray(TEXCOORD_ARRAY);

	gl.bindBuffer(gl.ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
}


/*!****************************************************************************
 @Function		Render3dModelsOcclusion
 @Description	Renders the visible city blocks based on the occlusion culling
                intersection data.
******************************************************************************/
//void OglES2Navigation3D::Render3dModelsOcclusion()
WebglNavigation3DSim.prototype.render3dModelsOcclusion = function(gl)
{
	////console.log("STARTSTARTSTARTSTARTSTARTSTARTSTARTSTARTSTARTSTARTSTART");
	// Find the nearest reference spot containing occlusion data
	let nearest_pos = 0;
    let nearest_pos_dist = 99999999999.9;
	for (let i=0; i < this.m_uiNumOcclusionData; i++)
	{
		
		let dist =  PVRVector3.length2(  PVRVector3.subtract (this.m_paPVRTOcclusionData[i].position , m_vCameraFrom) );//    lenSqr();
		if (dist < nearest_pos_dist)
		{
			nearest_pos_dist = dist;
			nearest_pos = i;
		}
	}

	// Extract the view frustum planes for coarse culling
	let planes = [new PVRVector4(), new PVRVector4(),new PVRVector4(),new PVRVector4()];
	this.extractViewFrustumPlanes(m_mViewProjectionMatrixNonRotated, planes[0], planes[1], planes[2], planes[3]);

	gl.useProgram(m_CityEntityShader.uiId);
	gl.uniformMatrix4fv(m_CityEntityShader.uiModelViewProjMatrixLoc,  gl.FALSE, m_mViewProjectionMatrix.data);
	gl.uniform3fv(m_CityEntityShader.uiLightDirectionLoc,  m_vLightDirection.data);

	// Enable the vertex attribute arrays
	gl.enableVertexAttribArray(VERTEX_ARRAY);
	gl.enableVertexAttribArray(NORMAL_ARRAY);
	gl.enableVertexAttribArray(TEXCOORD_ARRAY);

	let prevTexture = {};

	let pRefData = this.m_paPVRTOcclusionData[nearest_pos]; //PVRTOcclusionData *
	for (let i=0; i< pRefData.numRefObjects; i++)
	{
		const  numRefObjects = pRefData.pNumRefObject[i];
		const  refTile = pRefData.pRefTile[i];
		const  pRefObjects = pRefData.ppRefObjects[i];

		const  lodReferencePosition = new PVRVector2(m_vCameraFrom.data[0], m_vCameraFrom.data[1]);
		const  sqDist = PVRVector2.length2  (PVRVector2.subtract (PVRVector2.scalarMultiply(   PVRVector2.add(this.m_paPVRTCityBlocks[refTile].boundingbox.maxCoords , this.m_paPVRTCityBlocks[refTile].boundingbox.minCoords) , 0.5) , lodReferencePosition)) ;//.lenSqr();
let  lod = (this.m_paPVRTCityBlocks[i].numLod - 1);
		for (let j=0; j < this.m_paPVRTCityBlocks[refTile].numLod; j++)
		{
			if (sqDist < this.m_afSquaredLodDistances[j])
			{
				lod = j;
				break;
			}
		}

		const pLod = this.m_paPVRTCityBlocks[refTile].paLod[lod]; //PVRTCityBlockLod *
		if (!pLod.bLoaded)continue;

		// Check whether we shall employ view frustum culling, initialise as visible
		let cullingtest = INTERSECT_FULL;
		if (m_abStates[STATE_CULLING])
			cullingtest = this.boundingBoxIntersectsFrustum(this.m_paPVRTCityBlocks[refTile].boundingbox, planes);

		// Skip the tile if it is not visible
		if (INTERSECT_NONE === cullingtest)
			continue;

		gl.bindBuffer(gl.ARRAY_BUFFER, pLod.vbos[0]);
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, pLod.vbos[1]);

	// // Enable the vertex attribute arrays
	// gl.enableVertexAttribArray(VERTEX_ARRAY);
	// gl.enableVertexAttribArray(NORMAL_ARRAY);
	// gl.enableVertexAttribArray(TEXCOORD_ARRAY);

	
		for (let j=0; j < numRefObjects; j++)
		{

		
			const pObjectSet = pLod.paObjects[pRefObjects[j]]; //PVRTCityBlockEntity *
			let objectvisible = INTERSECT_FULL;

			// If the tile is only partially within the frustum, test whether the current object is visible
			// otherwise assume full visibility
			if (m_abStates[STATE_CULLING] && (cullingtest === INTERSECT_PARTIAL))
				objectvisible = this.boundingBoxIntersectsFrustum(pObjectSet.boundingbox, planes);

			if (INTERSECT_NONE === objectvisible)
				continue;
				
			for (let k=0; k<  pObjectSet.numSubObjects; k++)
			{
				
			if	(!pObjectSet.render[k] ) {continue;}

				let stride =  32;//sizeof(PVRTModelVertex);

				if (pObjectSet.pauiTextures[k] !== prevTexture)
				{
					
					gl.activeTexture(gl.TEXTURE0);
					gl.bindTexture(gl.TEXTURE_2D, pObjectSet.pauiTextures[k]);
					prevTexture = pObjectSet.pauiTextures[k];
				}
				

				gl.vertexAttribPointer(VERTEX_ARRAY, 3, gl.FLOAT, gl.FALSE, stride, 0);
				gl.vertexAttribPointer(NORMAL_ARRAY, 3, gl.FLOAT, gl.FALSE, stride, 12);
				gl.vertexAttribPointer(TEXCOORD_ARRAY, 2, gl.FLOAT, gl.FALSE, stride, 24);
			  // gl.vertexAttribPointer(TEXCOORD_ARRAY, 2, gl.FLOAT, pObjectSet.render[k], stride, 24);
			

				gl.drawElements(gl.TRIANGLES, pObjectSet.paNumIndices[k], gl.UNSIGNED_SHORT, pObjectSet.paIndexOffsets[k]*2);//(void *)(pObjectSet->paIndexOffsets[k]*sizeof(gl.ushort)
				//  let error =  gl.getError()
				// if( (error !== 0)) {

				// 	//console.log(refTile, lod, pRefObjects[j], pObjectSet.paNumIndices[k] , pObjectSet.paIndexOffsets[k], pLod);
				// 	for (let m = 0 ; m < pObjectSet.paNumIndices[k]; m++){
				// 		let index = pLod.pIndices[m+ pObjectSet.paIndexOffsets[k]];
				// 		//console.log(index);
				// 		//console.log(pLod.array.length);
				// 		//console.log(pLod.array[index*8],pLod.array[index*8+1],pLod.array[index*8+2],pLod.array[index*8+3],pLod.array[index*8+4],
				// 			pLod.array[index*8+5],pLod.array[index*8+6],pLod.array[index*8+7]); 
				// 	}
					
	
					
				// 	this.isRender3dModelsOcclusion = 1
				// 	return;
				// }
				// else{
                //       total += 1
				// }
// 				if( (error !== 0)) {
// 					if (refTile===9 && lod === 0)	//console.log(pRefObjects[j],k);
// 					// gl.vertexAttribPointer(TEXCOORD_ARRAY, 2, gl.FLOAT, true, stride, 24);
// 					// gl.drawElements(gl.TRIANGLES, pObjectSet.paNumIndices[k], gl.UNSIGNED_SHORT, pObjectSet.paIndexOffsets[k]);//(void *)(pObjectSet->paIndexOffsets[k]*sizeof(gl.ushort)
			
// 					//  errortotal += 1;
// 					//  total += 1;

// 					if (refTile===9 && lod === 0 && pRefObjects[j] === 77 && k ===1 ){
// 						//console.log(error);

//   //console.log(pObjectSet.paIndexOffsets[k]);
//   //console.log(pObjectSet.paNumIndices[k]);		
// 				//console.log(pLod.pszFilename);
// 						//console.log("bad 1")
					
// 					}
// 					else  if (refTile===9 && lod === 0 && pRefObjects[j] === 77 && k ===0 ){//console.log("bad 0")};
// 					 ////console.log(pLod.pszFilename);
// 					 ////console.log(this.isRender3dModelsOcclusion);
// 				 	////console.log("refTile"+refTile.toString()+"lod"+lod.toString()+"i"+pRefObjects[j].toString()+"j"+k.toString());}
// 				 }
// 			else{
// 				if (refTile===9 && lod === 0 && pRefObjects[j] === 77 && k ===1 ){//console.log("good 1")}
// 				else  if (refTile===9 && lod === 0 && pRefObjects[j] === 77 && k ===0 ){//console.log("good 0")};
		   
// // total+=1 ;
// ////console.log("error rate", errortotal/total);
// 			}
		}
		}

	
	}


////console.log("endendendendendendendendendendendend");
gl.disableVertexAttribArray(VERTEX_ARRAY);
gl.disableVertexAttribArray(NORMAL_ARRAY);
gl.disableVertexAttribArray(TEXCOORD_ARRAY);

	gl.bindBuffer(gl.ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
	//this.isRender3dModelsOcclusion = 0
}



let PVRTModelVertexArray = function(data){

	let p = new  Float32Array(data.buffer);
   let length = p.length / 8;
   let array = new Array(length);
   var pos = 0;
   for(let i = 0 ; i < length; i++){
		array[i] = new PVRTModelVertex();
		array[i].position = new PVRVector3(p[pos++],p[pos++],p[pos++]);
		array[i].normal = new PVRVector3(p[pos++],p[pos++],p[pos++]);
		array[i].texcoord = new PVRVector2(p[pos++],p[pos++]);
   }

   return array;
}


let FromPVRTModelVertexArrayToFloat32Array = function(data){
   let length = data.length;  
   let array =  new  Float32Array(length * 8);
   let arrayPos= 0;
   for(let i = 0 ; i < length; i++){
	   let p = data[i];
	   let pos = p.position.data;
		array[arrayPos++]     = pos[0];
		array[arrayPos++]     = pos[1];
		array[arrayPos++]     = pos[2];
	    pos = p.normal.data;
		array[arrayPos++]     = pos[0];
		array[arrayPos++]     = pos[1];
		array[arrayPos++]     = pos[2];
		pos = p.texcoord.data;
		array[arrayPos++]     = pos[0];
		array[arrayPos++]     = pos[1];
   }
   //console.log(arrayPos);
   return array;
}


/*!****************************************************************************
 @Function		RenderSkyBox
 @Description	Renders a sky box centered around the view position.
******************************************************************************/
//void OglES2Navigation3D::RenderSkyBox()
WebglNavigation3DSim.prototype.renderSkyBox = function(gl)
{
	let t1 = PVRVector3.subtract( m_vCameraTo , m_vCameraFrom).data;
	
	let t2 = PVRMatrix4x4.multiply(m_mMouseLookMatrix , new  PVRVector4( t1[0],t1[1],t1[2] , 0.0)).data;
	
	let viewdir = new PVRVector3 (t2[0],t2[1],t2[2]);


	let t3 = PVRMatrix4x4.multiply(m_mMouseLookMatrix , new PVRVector4(m_vCameraUp.data[0], m_vCameraUp.data[1],m_vCameraUp.data[2]  , 0.0)).data;
	let updir = new PVRVector3 (t3[0],t3[1],t3[2]);
	
	let mv_matrix =  PVRMatrix4x4.createLookAt(new PVRVector3(0.0, -5.0, 0.0),  PVRVector3.add(viewdir,new PVRVector3(0.0, -5.0, 0.0)),     updir);
	let mvp_matrix = PVRMatrix4x4.multiply( m_mProjectionMatrix , mv_matrix);

	gl.useProgram(m_SkyboxShader.uiId);

	gl.uniformMatrix4fv(m_SkyboxShader.uiModelViewProjMatrixLoc,  gl.FALSE, mvp_matrix.data);

	gl.bindBuffer(gl.ARRAY_BUFFER, m_uiSkyboxVBO);
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

//	alert(this.m_uiTextureIdSkybox);

	gl.activeTexture(gl.TEXTURE0);
	gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.m_uiTextureIdSkybox);

	// Enable the vertex attribute arrays
	gl.enableVertexAttribArray(VERTEX_ARRAY);
	//gl.vertexAttribPointer(VERTEX_ARRAY, 3, gl.FLOAT, gl.FALSE, sizeof(new PVRVector3), null);
	gl.vertexAttribPointer(VERTEX_ARRAY, 3, gl.FLOAT, gl.FALSE, 20, 0);

	// Draw primitive
	for(let i = 0; i < 6; ++i){
	gl.drawArrays(gl.TRIANGLE_STRIP, i*4, 4);}

	gl.disableVertexAttribArray(VERTEX_ARRAY);

	gl.bindBuffer(gl.ARRAY_BUFFER, null);
}




let loadModelVbo = function(stream, gl, pLod, demo)
    {


 

		pLod.model = new PVRModel();
	if (pLod.debug) {//console.log(pLod.pszFilename);
		pLod.model.debug = true;
	}


		let podLoader    = new PVRPODLoader();
		let result       = podLoader.load(stream, pLod.model);
	
		if(result !== EPODErrorCodes.eNoError)
		{
			pLod.bLoaded = false;
			demo.totalLoadVBO--; //alert("Failed to loadModelVbo: " + pLod.pszFilename);
			return;
		}
	

	// let model = new CPVRTModelPOD();

	// if (PVR_FAIL === model.ReadFromFile(pLod.pszFilename))
	// 		return;
	// else

	pLod.bLoaded = true;


     let totalVertexCount = 0;
	 let totalIndexCount = 0;

	for (let  i=0; i < pLod.numObjects; i++)
	{
		const  numSubObjects = pLod.paObjects[i].numSubObjects;

		pLod.paObjects[i].paNumIndices = new Array(numSubObjects);
		pLod.paObjects[i].paIndexOffsets = new Array(numSubObjects);
		pLod.paObjects[i].pauiTextures = new Array(numSubObjects);
		pLod.paObjects[i].render = new Array(numSubObjects);
		for (let j=0; j < pLod.paObjects[i].numSubObjects; j++)
		{
		
			
		



			const  mesh_index = pLod.model.data.nodes[pLod.paObjects[i].pNodeIdx[j]].data.index;
			
			const mesh = pLod.model.data.meshes[mesh_index]; //SPODMesh &


			totalVertexCount +=   mesh.data.primitiveData.numVertices;   //mesh.nNumVertex; 
			
			
			totalIndexCount +=  mesh.GetNumberOfIndices();  // PVRTModelPODCountIndices(mesh);


			pLod.paObjects[i].paNumIndices[j] = mesh.GetNumberOfIndices();//PVRTModelPODCountIndices(mesh);
		
			
			
			if (pLod.model.data.materials)
			{

				
				const  material_index = pLod.model.data.nodes[pLod.paObjects[i].pNodeIdx[j]].data.materialIndex;//nIdxMaterial;
				const texture = pLod.model.data.textures[pLod.model.data.materials[material_index].data.diffuseTextureIndex]; //SPODTexture &
				// Pre-init with invalid texture handle
			

				pLod.paObjects[i].pauiTextures[j] = {};
               let find = false;
				for (let k=0; k < m_uiNumTextures; k++)
				{
					
					if (texture.data.name === c_paszTextures[k])
					{
					
						pLod.paObjects[i].pauiTextures[j] = demo.m_pauiTextureIds[k];
					    find = true;
						break;
					}
				}

				//if (find === false){alert(texture.data.name);}
			}
		}
	}

	if (totalVertexCount > 65536 || totalIndexCount > 65536 )
	{
	//("too many vertexs");
		pLod.bLoaded = false;
		return;
	}

	let pIndices = new   Uint16Array(totalIndexCount) ;//gl.ushort[totalIndexCount];
	let pVertices = new Array(totalVertexCount);  //PVRTModelVertex
     for (let i = 0 ; i<totalVertexCount; i++ ){
	pVertices[i] = new PVRTModelVertex();
  }

	let indexOffset = 0;
	let  vertexOffset = 0;
	for (let i=0; i < pLod.numObjects; i++)
	{
		for (let j=0; j < pLod.paObjects[i].numSubObjects; j++)
		{   
			const  mesh_index = pLod.model.data.nodes[pLod.paObjects[i].pNodeIdx[j]].data.index;//nIdx;
			const  mesh = pLod.model.data.meshes[mesh_index]; //SPODMesh
			const  numIndices = mesh.GetNumberOfIndices();//PVRTModelPODCountIndices(mesh); //unsigned int
	
		  //  let pSrcVertices =   new Float32Array( mesh.data.vertexElementData[0] ); //  mesh.pInterleaved; //	PVRTModelVertex *
		  let pSrcVertices = new  PVRTModelVertexArray( mesh.data.vertexElementData[0] ); //  mesh.pInterleaved; //	PVRTModelVertex *
		 let pSrcIndices =  mesh.data.faces.data;  // sFaces.pData; //(gl.ushort *)

			pLod.paObjects[i].paIndexOffsets[j] = indexOffset;

		

			if (i===70 && j ===2 && pLod.debug) {
				//console.log(pLod.paObjects[i].pNodeIdx[j]);
			//console.log("error there");
			//console.log("meshindex",mesh_index);
			//console.log(mesh);
			//console.log("pSrcVertices",pSrcVertices);
			//console.log("mesh.data.faces.data",mesh.data.faces.data);
			
			}
			// else if (i===77 && j ===0 && pLod.debug) {
				
			// 	//console.log("good there");
			// 	//console.log(mesh);
			// 	//console.log("pSrcVertices",pSrcVertices);
			// 	//console.log("mesh.data.faces.data",mesh.data.faces.data);
				
			// 	}

			// 	 if (i===80  && pLod.debug) {
			// 		 //console.log(pLod.paObjects[i].pNodeIdx[j]);
			// //	//console.log(pLod.model.data);
			// 	//console.log("meshindex",mesh_index);
			// 		// //console.log("good there", j);
			// 		//console.log(mesh);
			// 		 //console.log("pSrcVertices",indexOffset);
			// 		// //console.log("mesh.data.faces.data",mesh.data.faces.data);
					
			// 		}
	

					pLod.paObjects[i].render[j] = true

					let ptempVertices = new Array(mesh.data.primitiveData.numVertices);

			for (let k=0; k < mesh.data.primitiveData.numVertices; k++)
			{
				const  normal = pSrcVertices[k].normal;
				pVertices[vertexOffset + k].normal = new PVRVector3(normal.data[0], -normal.data[2], normal.data[1]);
				const   position = pSrcVertices[k].position;
				pVertices[vertexOffset + k].position = new PVRVector3(position.data[0], -position.data[2], position.data[1]);
				const  texcoord = pSrcVertices[k].texcoord;
			   pVertices[vertexOffset + k].texcoord = new PVRVector2(texcoord.data[0], texcoord.data[1])
			
			
			
			   ptempVertices[k]= new PVRTModelVertex();

			    ptempVertices[k].normal = new PVRVector3(normal.data[0], -normal.data[2], normal.data[1]);
				ptempVertices[k].position = new PVRVector3(position.data[0], -position.data[2], position.data[1]);
				ptempVertices[k].texcoord = new PVRVector2(texcoord.data[0], texcoord.data[1])
			}



			let ptempIndices = new   Uint16Array(numIndices) ;

			for (let k=0; k < numIndices; k++){
		pIndices[indexOffset + k] = pSrcIndices[k] + vertexOffset;
		ptempIndices[k] = pSrcIndices[k] ;
	}
	 //(gl.ushort)}}
			


		
		if (i===70 && j ===2 && pLod.debug) {
	
	

	let length = ptempVertices.length;  
	let array =  new  Float32Array(length * 8);
	let arrayPos= 0;
	for(let i = 0 ; i < length; i++){
		let p = ptempVertices[i];
		let pos = p.position.data;
		 array[arrayPos++]     = pos[0];
		 array[arrayPos++]     = pos[1];
		 array[arrayPos++]     = pos[2];
		 pos = p.normal.data;
		 array[arrayPos++]     = pos[0];
		 array[arrayPos++]     = pos[1];
		 array[arrayPos++]     = pos[2];
		 pos = p.texcoord.data;
		 array[arrayPos++]     = pos[0];
		 array[arrayPos++]     = pos[1];
	}
	//console.log("array",new  Uint8Array( array.buffer));
	//console.log("ptempIndices", new Uint8Array(ptempIndices.buffer));
}
		
		vertexOffset += mesh.data.primitiveData.numVertices; //mesh.nNumVertex;
		indexOffset += numIndices;
		
	}

		
	}

	

// let pIndicesLength = pIndices.length * 2;
// let top = new Uint8Array(pIndices.buffer);
// for (let i =0; i< pIndicesLength; i+=2){
// 	let x = top[i];
// 	top[i] = top[i+1];
// top[i+1] =x;
// }
// pIndices = new Uint16Array(pIndices.buffer);

	//let value = FromPVRTModelVertexArrayToFloat32Array(pVertices);


	let length = pVertices.length;  
	let array =  new  Float32Array(length * 8);
	let arrayPos= 0;
	for(let i = 0 ; i < length; i++){
		let p = pVertices[i];
		let pos = p.position.data;
		 array[arrayPos++]     = pos[0];
		 array[arrayPos++]     = pos[1];
		 array[arrayPos++]     = pos[2];
		 pos = p.normal.data;
		 array[arrayPos++]     = pos[0];
		 array[arrayPos++]     = pos[1];
		 array[arrayPos++]     = pos[2];
		 pos = p.texcoord.data;
		 array[arrayPos++]     = pos[0];
		 array[arrayPos++]     = pos[1];
	}

	
	pLod.array = array;
	pLod.pIndices = pIndices;
	pLod.model = null;
	//  pLod.vbos[0] = gl.createBuffer();
	//  pLod.vbos[1] = gl.createBuffer();


	// gl.bindBuffer(gl.ARRAY_BUFFER, pLod.vbos[0]);
	// gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, pLod.vbos[1]);
	
	// //gl.bufferData(gl.ARRAY_BUFFER, totalVertexCount * sizeof(PVRTModelVertex), pVertices, gl.STATIC_DRAW);
	// gl.bufferData(gl.ARRAY_BUFFER,  array , gl.STATIC_DRAW);
	// //gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, totalIndexCount * sizeof(gl.ushort), pIndices, gl.STATIC_DRAW);
	// gl.bufferData(gl.ELEMENT_ARRAY_BUFFER,  pIndices, gl.STATIC_DRAW);
	
	// gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
	// gl.bindBuffer(gl.ARRAY_BUFFER, null);

	 demo.totalLoadVBO --;
	

}  

/*!****************************************************************************
 @Function		CreateModelVbo
 @Description	Loads a city block from file and creates vertex buffer objects.
                The model itself is being modified as the y and z axis are swapped
				and the resulting y axis has to be negated to coincide with 2D
				map data.
******************************************************************************/
//void OglES2Navigation3D::CreateModelVbo(const unsigned int tile, const unsigned int lod)
WebglNavigation3DSim.prototype.createModelVbo = function(gl, tile, lod)
{



	let pLod = this.m_paPVRTCityBlocks[tile].paLod[lod]; //PVRTCityBlockLod *
 if (tile === 0  && lod === 1) {pLod.debug = true;}
else {pLod.debug = false;}
	(function(gl, pLod,demo)
	{
		let fs = new PVRFileStream();
		
		fs.Open(getFileLocation(pLod.pszFilename), true, loadModelVbo, gl, pLod, demo);
	})(gl, pLod,this);

	




}

/*!****************************************************************************
 @Function		ReleaseModelVbo
 @Description	Releases all resources and memory related with a certain city block.
******************************************************************************/
//void OglES2Navigation3D::ReleaseModelVbo(const unsigned int tile, const unsigned int lod)

WebglNavigation3DSim.prototype.releaseModelVbo = function(tile, lod)
{
	let pLod = this.m_paPVRTCityBlocks[tile].paLod[lod];

	for (let  i=0; i < pLod.numObjects; i++)
	{
		 pLod.paObjects[i].paNumIndices = null;
		 pLod.paObjects[i].paIndexOffsets = null;
		pLod.paObjects[i].pauiTextures = null;

		// pLod.paObjects[i].paNumIndices = 0;
		// pLod.paObjects[i].paIndexOffsets = 0;
		// pLod.paObjects[i].pauiTextures =  [] ;
	}
}


/*!****************************************************************************
 @Function		CalculateLightMatrices
 @Description	TODO
******************************************************************************/
//void OglES2Navigation3D::CalculateLightMatrices()
WebglNavigation3DSim.prototype.calculateLightMatrices = function()
{

	let lightDir = new PVRVector3(0.1, 0.1, -1.0)
	lightDir.normalise(); // .normalized();
	let t = PVRMatrix4x4.multiply( m_mMouseLightMatrix ,new  PVRVector4(lightDir.data[0], lightDir.data[1], lightDir.data[2], 0.0)).data;
	
	m_vLightDirection = new PVRVector3(t[0],t[1],t[2]);
	}


/*!****************************************************************************
 @Function		GetCameraFrame
 @Description	Retrieves camera frame from the active camera path and converts
                the units from imperial to metric system.
******************************************************************************/
//void OglES2Navigation3D::GetCameraFrame(new PVRVector3 &from, new PVRVector3 &to, new PVRVector3 &up, float time)
WebglNavigation3DSim.prototype.getCameraFrame = function( time)
{
	

	this.m_CameraPod.setCurrentFrame(time);

	let props = this.m_CameraPod.getCameraProperties(this.m_ActiveCameraTrack);

    let  to = props.to;
    let  from =  props.from ;
    let  up = props.up;

	//this.m_CameraPod.GetCamera(from, to, up, this.m_ActiveCameraTrack);
	from = PVRVector3.scalarMultiply(from,  0.0254);
	to =  PVRVector3.scalarMultiply (to, 0.0254);

	from = new PVRVector3(from.data[0], -from.data[2], from.data[1]);
	to = new PVRVector3(to.data[0], -to.data[2], to.data[1]);
	up = new PVRVector3(up.data[0], -up.data[2], up.data[1]);

	let value = {}
	value.from = from;
	value.to = to;
	value.up = up;
	return value

}

/*!****************************************************************************
 @Function		CalculateCameraMatrices
 @Description	Calculates and interpolates the current camera frame. The
                interpolation is being done to prevent the camera from stuttering
				at slow speed passages (due to floating point issues).
******************************************************************************/
//void OglES2Navigation3D::CalculateCameraMatrices()
WebglNavigation3DSim.prototype.calculateCameraMatrices = function()
{


	let clamped_delta = m_fCameraAnimation + 5.0;
	if (clamped_delta > (this.m_CameraPod.data.numFrames - 1)){
		clamped_delta -= (this.m_CameraPod.data.numFrames - 1);
	}
    if (clamped_delta < m_fCameraAnimation){return};

let v1 =	this.getCameraFrame( m_fCameraAnimation);

let now_from  = v1.from;
	let now_to = v1.to;
	let now_up = v1.up;
	
	
let v2 = 	this.getCameraFrame( clamped_delta);

let next_from = v2.from;
	let  next_to = v2.to;
	let  next_up = v2.up;

	m_vCameraFrom = now_from;
	
	let next = PVRVector3.subtract (next_from , now_from);
	next.normalise();
	m_vCameraTo = PVRVector3.add( now_from , next);
	m_vCameraUp = now_up;



	m_mProjectionMatrix = PVRMatrix4x4.createPerspectiveProjection(this.m_fNearClipPlane, this.m_fFarClipPlane, this.m_fFOV, this.m_fAspectRatio)
	
	//(this.m_fFOV, this.m_fAspectRatio, this.m_fNearClipPlane, this.m_fNearClipPlane, new PVRMatrix4x4::Ogl, m_bRotate);
	// new PVRVector3 viewdir = (m_mMouseLookMatrix * new PVRVector4(m_vCameraTo - m_vCameraFrom, 0.0));
	// new PVRVector3 updir(m_mMouseLookMatrix * new PVRVector4(m_vCameraUp, 0.0));

	// m_mViewMatrix = new PVRMatrix4x4::LookAtRH(m_vCameraFrom, m_vCameraFrom + viewdir, updir);
	// m_mViewProjectionMatrix = m_mProjectionMatrix * m_mViewMatrix;

	if (Math.abs(now_up.data[1]) > 1){return}
	let t1 = PVRVector3.subtract( m_vCameraTo , m_vCameraFrom).data;
	let t2 = PVRMatrix4x4.multiply(m_mMouseLookMatrix , new  PVRVector4( t1[0],t1[1],t1[2] , 0.0)).data;
	let viewdir = new PVRVector3 (t2[0],t2[1],t2[2]);

	let t3 = PVRMatrix4x4.multiply(m_mMouseLookMatrix , new PVRVector4(m_vCameraUp.data[0], m_vCameraUp.data[1],m_vCameraUp.data[2]  , 0.0)).data;
	let updir = new PVRVector3 (t3[0],t3[1],t3[2]);

	m_mViewMatrix =  PVRMatrix4x4.createLookAt(m_vCameraFrom,  PVRVector3.add(viewdir,m_vCameraFrom),  updir);
	m_mViewProjectionMatrix = PVRMatrix4x4.multiply( m_mProjectionMatrix , m_mViewMatrix);



	if (!m_bRotate)
		m_mViewProjectionMatrixNonRotated = m_mViewProjectionMatrix;
	else
		m_mViewProjectionMatrixNonRotated = PVRMatrix4x4.multiply( new PVRMatrix4x4.createPerspectiveProjection(this.m_fNearClipPlane, this.m_fFarClipPlane,this.m_fFOV, 1.0 / this.m_fAspectRatio),m_mViewMatrix);
		
		//::PerspectiveFovRH(this.m_fFOV, 1.0f / this.m_fAspectRatio, this.m_fNearClipPlane, this.m_fNearClipPlane, new PVRMatrix4x4::Ogl, false) * m_mViewMatrix;
}

/*!****************************************************************************
 @Function		ExtractViewFrustumPlanes
 @Description	Extracts the (left, right, front and back) view frustum planes
                from the camera modelview-projection matrix.
******************************************************************************/
//void OglES2Navigation3D::ExtractViewFrustumPlanes(const new PVRMatrix4x4 &matrix, new PVRVector4 &left, new PVRVector4 &right, new PVRVector4 &front, new PVRVector4 &back) const
WebglNavigation3DSim.prototype.extractViewFrustumPlanes = function(matrix, left, right, front, back)
{
	left.data[0] = (matrix.data[3]  + matrix.data[0]);
    left.data[1] = (matrix.data[7]  + matrix.data[4]);
    left.data[2] = (matrix.data[11] + matrix.data[8]);
	left.data[3] = (matrix.data[15] + matrix.data[12]);
	let inv_len = 1.0 / PVRVector3.vectorlength(new PVRVector3(left.data[0],left.data[1],left.data[2] ))  ;//length();
	left =  PVRVector4.scalarMultiply(left, inv_len);

	right.data[0] = (matrix.data[3]  - matrix.data[0]);
    right.data[1] = (matrix.data[7]  - matrix.data[4]);
    right.data[2] = (matrix.data[11] - matrix.data[8]);
	right.data[3] = (matrix.data[15] - matrix.data[12]);
	inv_len = 1.0 / PVRVector3.vectorlength(new PVRVector3(right.data[0],right.data[1],right.data[2] ))  ;//new PVRVector3(right).length();
	right = PVRVector4.scalarMultiply(right, inv_len);

	front.data[0] = (matrix.data[3]  + matrix.data[2]);
    front.data[1] = (matrix.data[7]  + matrix.data[6]);
    front.data[2] = (matrix.data[11] + matrix.data[10]);
	front.data[3] = (matrix.data[15] + matrix.data[14]);
	inv_len = 1.0 /   PVRVector3.vectorlength(new PVRVector3(front.data[0],front.data[1],front.data[2] ))  //new PVRVector3(front).length();
	front =  PVRVector4.scalarMultiply(front, inv_len);

	back.data[0] = (matrix.data[3]  - matrix.data[2]);
    back.data[1] = (matrix.data[7]  - matrix.data[6]);
    back.data[2] = (matrix.data[11] - matrix.data[10]);
	back.data[3] = (matrix.data[15] - matrix.data[14]);
	inv_len = 1.0 /  PVRVector3.vectorlength(new PVRVector3(back.data[0],back.data[1],back.data[2] ))//new PVRVector3(back).length();
	back =  PVRVector4.scalarMultiply(back, inv_len);
}



/*!****************************************************************************
 @Function		Load3dModelIndex
 @Description	Loads hierarchical index data (please see the 3D Navigation
                whitepaper for a file format description).
******************************************************************************/
//bool OglES2Navigation3D::Load3dModelIndex(const char *pszFilename, CPVRTString* pErrorStr)
WebglNavigation3DSim.prototype.load3dModelIndex = function(pszFilename)
{




        PVR3dModelIndex.loadFromURI(pszFilename, 0, this, 
		function( j, demo)
		{
			
			demo.m_pauiVisibleTiles = new Array(demo.m_uiNumPVRTCityBlocks); //new PVRTVisibilityInfo[demo.m_uiNumPVRTCityBlocks];
			demo.m_ppaShadowMesh = new Array(demo.m_uiNumPVRTCityBlocks);
			     // new PVRTShadowVolShadowMesh*[m_uiNumPVRTCityBlocks];
				 demo.m_ppaShadowVol =  new Array(demo.m_uiNumPVRTCityBlocks); // new PVRTShadowVolShadowVol*[m_uiNumPVRTCityBlocks];
				 demo.m_ppaVolumeScale =  new Array(demo.m_uiNumPVRTCityBlocks); //new float*[m_uiNumPVRTCityBlocks];
				 demo.m_paNumShadowVols =  new Array(demo.m_uiNumPVRTCityBlocks); //new unsigned int[m_uiNumPVRTCityBlocks];
				 demo.m_ppaShadowRenderID =  new Array(demo.m_uiNumPVRTCityBlocks);
				 demo.m_bUpdateShadowData = false;
		
			for (let i=0; i < demo.m_uiNumPVRTCityBlocks; i++)
			{
				demo.m_pauiVisibleTiles[i] = new PVRTVisibilityInfo();
				demo.m_ppaShadowMesh[i] =  [] ;
				demo.m_ppaShadowVol[i] =  [] ;
				demo.m_ppaShadowRenderID[i] =  [] ;
				demo.m_ppaVolumeScale[i] =  [] ;
				demo.m_paNumShadowVols[i] = {};
			}


			demo.totalLoadVBO = 0;
		
			for (let i = 0; i<demo.m_uiNumPVRTCityBlocks ; i++){
			for (let j=0; j < demo.m_paPVRTCityBlocks[i].numLod; ++j)
			{
			   demo.totalLoadVBO += 1

		   }}

		   demo.completeVBO = demo.totalLoadVBO

		  demo.m_load3dModelIndex &= ~(1<<j);
	

		});
return true;

}

/*!****************************************************************************
 @Function		Release3dModelIndex
 @Description	Releases the hierarchical index data.
******************************************************************************/
//void OglES2Navigation3D::Release3dModelIndex()
WebglNavigation3DSim.prototype.release3dModelIndex = function()
{
	for (let i=0; i < this.m_uiNumPVRTCityBlocks; i++)
	{
		for (let j=0; j < this.m_paPVRTCityBlocks[i].numLod; j++)
		{
			for (let k=0; k < this.m_paPVRTCityBlocks[i].paLod[j].numObjects; k++)
			{
				 this.m_paPVRTCityBlocks[i].paLod[j].paObjects[k].pNodeIdx = null
			 this.m_paPVRTCityBlocks[i].paLod[j].paObjects[k].paNumIndices = null;
			 this.m_paPVRTCityBlocks[i].paLod[j].paObjects[k].paIndexOffsets= null;
				 this.m_paPVRTCityBlocks[i].paLod[j].paObjects[k].pauiTextures = null;
			}
		this.m_paPVRTCityBlocks[i].paLod[j].paObjects = null;
		 this.m_paPVRTCityBlocks[i].paLod[j].paVisibleNodes = null;
			this.m_paPVRTCityBlocks[i].paLod[j].pszFilename = null;
		}
	 this.m_paPVRTCityBlocks[i].paLod = null;
	}
	this.m_paPVRTCityBlocks= null;
}


/*!****************************************************************************
 @Function		LoadOcclusionData
 @Description	Loads the occlusion (/visibility) data information (please see
                the 3D Navigation whitepaper for a file format description).
******************************************************************************/
//bool OglES2Navigation3D::LoadOcclusionData(const char *pszFilename, CPVRTString* pErrorStr)
WebglNavigation3DSim.prototype.loadOcclusionData = function(pszFilename)
{


	// CPVRTResourceFile file(pszFilename);
	// if (!file.IsOpen())
	// {
	// 	*pErrorStr = "Error: Could not open occlusion data!\n";
	// 	return false;
	// }


       PVROcclusion.loadFromURI(pszFilename, 1, this, 
		function( j, demo)
		{
		
		   demo.m_load3dModelIndex &= ~(1<<j);
	

		});
		
		return true;


	// const char *pData = (const char *)file.DataPtr();

	// PVRTuint32 namelen;
	// memcpy((char *)&namelen, pData, sizeof(namelen));
	// pData += sizeof(namelen);
	// // Skip the name
	// pData += namelen;

	// PVRTuint32 numTiles;
	// memcpy((char *)&numTiles, pData, sizeof(numTiles));
	// pData += sizeof(numTiles);
	// for (unsigned int i=0; i < numTiles; i++)
	// {
	// 	memcpy((char *)&namelen, pData, sizeof(namelen));
	// 	pData += sizeof(namelen);
	// 	// Skip the name
	// 	pData += namelen;
	// }

	// PVRTuint32 numpositions;
	// memcpy((char *)&numpositions, pData, sizeof(numpositions));
	// pData += sizeof(numpositions);
	// m_uiNumOcclusionData = (unsigned int)numpositions;

	// m_paPVRTOcclusionData = new PVRTOcclusionData[m_uiNumOcclusionData];

	// for (unsigned int i=0; i < m_uiNumOcclusionData; i++)
	// {
	// 	memcpy((char *)&m_paPVRTOcclusionData[i].position, pData, sizeof(new PVRVector3));
	// 	pData += sizeof(new PVRVector3);

	// 	PVRTuint32 reftiles;
	// 	memcpy((char *)&reftiles, pData, sizeof(reftiles));
	// 	pData += sizeof(reftiles);

	// 	m_paPVRTOcclusionData[i].numRefObjects = (unsigned int)reftiles;
	// 	m_paPVRTOcclusionData[i].pRefTile = new unsigned int[reftiles];
	// 	m_paPVRTOcclusionData[i].pNumRefObject = new unsigned int[reftiles];
	// 	m_paPVRTOcclusionData[i].ppRefObjects = new unsigned int*[reftiles];

	// 	for (unsigned int j=0; j < reftiles; j++)
	// 	{
	// 		PVRTuint32 tilenum;
	// 		memcpy((char *)&tilenum, pData, sizeof(tilenum));
	// 		pData += sizeof(tilenum);
	// 		m_paPVRTOcclusionData[i].pRefTile[j] = (unsigned int)tilenum;

	// 		PVRTuint32 num_ref_models;
	// 		memcpy((char *)&num_ref_models, pData, sizeof(num_ref_models));
	// 		pData += sizeof(num_ref_models);

	// 		m_paPVRTOcclusionData[i].pNumRefObject[j] = (unsigned int)num_ref_models;
	// 		m_paPVRTOcclusionData[i].ppRefObjects[j] = new unsigned int[num_ref_models];
	// 		memcpy((char *)m_paPVRTOcclusionData[i].ppRefObjects[j], pData, sizeof(unsigned int) * num_ref_models);
	// 		pData += sizeof(unsigned int) * num_ref_models;
	// 	}
	// }

	// return true;
}

/*!****************************************************************************
 @Function		ReleaseOcclusionData
 @Description	Releases all occlusion data.
******************************************************************************/
//void OglES2Navigation3D::ReleaseOcclusionData()
WebglNavigation3DSim.prototype.releaseOcclusionData = function()
{
	for (let i=0; i < this.m_uiNumOcclusionData; i++)
	{
		for (let j=0; j < this.m_paPVRTOcclusionData[i].numRefObjects; j++)
			 this.m_paPVRTOcclusionData[i].ppRefObjects[j] = null
	    this.m_paPVRTOcclusionData[i].pNumRefObject = null;
		this.m_paPVRTOcclusionData[i].pRefTile = null;
		this.m_paPVRTOcclusionData[i].ppRefObjects = null
	}

	 this.m_paPVRTOcclusionData = null;
}

/*!****************************************************************************
 @Function		BoundingBoxIntersectsFrustum
 @Description	Tests whether a 2D bounding box is intersected or enclosed
                by a camera view frustum. Only the front, left, right and back
				planes of the view frustum are taken into consideration to
				optimize the intersection test.
******************************************************************************/
//int OglES2Navigation3D::BoundingBoxIntersectsFrustum(const PVRTBoundingBox2D &bbox, const new PVRVector4 planes[4]) const
WebglNavigation3DSim.prototype.boundingBoxIntersectsFrustum = function(bbox, planes)
{
	let totalinside = 0;

	// Test the axis-aligned bounding box against each plane;
	// only cull if all points are outside of one the view frustum planes
	for (let p=0; p < 4; p++)
	{
		let pointsOut = 0;

		// Test the points against the plane
		if ((planes[p].data[0] * bbox.minCoords.data[0] + planes[p].data[1] * bbox.minCoords.data[1] + planes[p].data[3]) < 0.0)
			pointsOut++;
		if ((planes[p].data[0] * bbox.maxCoords.data[0] + planes[p].data[1] * bbox.minCoords.data[1] + planes[p].data[3]) < 0.0)
			pointsOut++;
		if ((planes[p].data[0] * bbox.maxCoords.data[0] + planes[p].data[1] * bbox.maxCoords.data[1] + planes[p].data[3]) < 0.0)
			pointsOut++;
		if ((planes[p].data[0] * bbox.minCoords.data[0] + planes[p].data[1] * bbox.maxCoords.data[1] + planes[p].data[3]) < 0.0)
			pointsOut++;

		// if all points are outside of a plane we can cull the whole bounding box
		if (pointsOut === 4)
			return INTERSECT_NONE;

		// if all points are inside of a plane, note it
		if (pointsOut === 0)
			totalinside++;
	}

	if (totalinside === 4)
		return INTERSECT_FULL;
	else
		return INTERSECT_PARTIAL;
}



let loadShadowVolume = function(stream,  pLod, demo,tile, gl)
		{

		  
			pLod.model = new PVRModel();
	
		let podLoader    = new PVRPODLoader();
		let result       = podLoader.load(stream, pLod.model);
		if(result !== EPODErrorCodes.eNoError)
		{
			
			//alert("Failed to load POD: " + result);
		       demo.completeVBO--;	
			return;
		}

		const  max_bbox_count = 256;
	    let bbox_array = new Array(max_bbox_count); //PVRTBoundingBox3D


		// if (PVR_SUCCESS !== model.ReadFromFile(this.m_paPVRTCityBlocks[tile].paLod[i].pszFilename))
		// 	continue;

		// PVRTCityBlockLod

		let count = 0;
		for (let j=0; j < pLod.numObjects; j++)
		{
			// Peek whether the current model is a building, if not skip it
			if (pLod.model.data.nodes[pLod.paObjects[j].pNodeIdx[0]].data.name === "BUILDING")
					continue;

			// Calculate the 3d bounding box for the whole building
			let bbox = new PVRTBoundingBox3D();
			bbox.minCoords = new PVRVector3(FLT_MAX,FLT_MAX,FLT_MAX );
			bbox.maxCoords = new PVRVector3(-FLT_MAX, -FLT_MAX, -FLT_MAX);
			for (let k=0; k < pLod.paObjects[j].numSubObjects; k++)
			{
				 let pNode = pLod.model.data.nodes[pLod.paObjects[j].pNodeIdx[k]]; //SPODNode
				 let pMesh = pLod.model.data.meshes[pNode.data.index]; //SPODMesh
				 let pData = new PVRTModelVertexArray(  pMesh.data.vertexElementData[0] ); //pMesh.pInterleaved; //PVRTModelVertex
				for (let n=0; n < pMesh.data.primitiveData.numVertices; n++)
				{
				  let vertex = new PVRVector3(pData[n].position.data[0], -pData[n].position.data[2], pData[n].position.data[1]);
					bbox.minCoords.data[0] = Math.min(bbox.minCoords.data[0], vertex.data[0]);
					bbox.minCoords.data[1] = Math.min(bbox.minCoords.data[1], vertex.data[1]);
					bbox.minCoords.data[2] = Math.min(bbox.minCoords.data[2], vertex.data[2]);
					bbox.maxCoords.data[0] = Math.max(bbox.maxCoords.data[0], vertex.data[0]);
					bbox.maxCoords.data[1] = Math.max(bbox.maxCoords.data[1], vertex.data[1]);
					bbox.maxCoords.data[2] = Math.max(bbox.maxCoords.data[2], vertex.data[2]);
				}
			}

			// If the whole building is flat, skip it
			if (bbox.minCoords.data[2] === bbox.maxCoords.data[2])
					continue;

			bbox_array[count] = bbox;
              count += 1;
			if (count >= max_bbox_count)
					break;
		}

		if (count === 0)
		{
			demo.m_ppaShadowMesh[tile] = null;
			demo.m_ppaShadowVol[tile] = null;
			demo.m_ppaVolumeScale[tile] = null;
			demo.m_ppaShadowRenderID[tile] = null;
			demo.m_paNumShadowVols[tile] = 0;
			return;
		}

		demo.m_ppaShadowMesh[tile] = new Array(count); //PVRTShadowVolShadowMesh[count];
		demo.m_ppaShadowVol[tile] = new  Array(count); //PVRTShadowVolShadowVol[count];
		demo.m_ppaVolumeScale[tile] = new Float32Array(count); //   float[count];
		demo.m_ppaShadowRenderID[tile] = new Array(count);
		demo.m_paNumShadowVols[tile] = count;

		for (let j=0; j < count; j++)
		{
			let  bbox = bbox_array[j]; //PVRTBoundingBox3D
			// Reduce the size of the shadow casting bounding box to reduce depth-fighting artefacts
			let midCoord = PVRVector3.scalarMultiply( PVRVector3.add (bbox.maxCoords , bbox.minCoords) , 0.5);
			bbox.minCoords = PVRVector3.add( PVRVector3.scalarMultiply( PVRVector3.add (bbox.minCoords , midCoord) , 0.99) , midCoord);
			bbox.maxCoords = PVRVector3.add( PVRVector3.scalarMultiply( PVRVector3.subtract (bbox.maxCoords , midCoord) , 0.99) , midCoord);//(bbox.maxCoords - midCoord) * 0.99 + midCoord;

			let  pVertices = new Array(8);
			pVertices[0] = bbox.minCoords;
			pVertices[1] = new PVRVector3(bbox.maxCoords.data[0], bbox.minCoords.data[1], bbox.minCoords.data[2]);
			pVertices[2] = new PVRVector3(bbox.maxCoords.data[0], bbox.maxCoords.data[1], bbox.minCoords.data[2]);
			pVertices[3] = new PVRVector3(bbox.minCoords.data[0], bbox.maxCoords.data[1], bbox.minCoords.data[2]);
			pVertices[4] = new PVRVector3(bbox.minCoords.data[0], bbox.minCoords.data[1], bbox.maxCoords.data[2]);
			pVertices[5] = new PVRVector3(bbox.maxCoords.data[0], bbox.minCoords.data[1], bbox.maxCoords.data[2]);
			pVertices[6] = bbox.maxCoords;
			pVertices[7] = new PVRVector3(bbox.minCoords.data[0], bbox.maxCoords.data[1], bbox.maxCoords.data[2]);

		  let pIndices  = new Uint16Array(36)  //	unsigned short [36];
			pIndices[ 0] = 3; pIndices[ 1] = 2; pIndices[ 2] = 1;
			pIndices[ 3] = 3; pIndices[ 4] = 1; pIndices[ 5] = 0;

			pIndices[ 6] = 0; pIndices[ 7] = 1; pIndices[ 8] = 5;
			pIndices[ 9] = 0; pIndices[10] = 5; pIndices[11] = 4;

			pIndices[12] = 3; pIndices[13] = 0; pIndices[14] = 4;
			pIndices[15] = 3; pIndices[16] = 4; pIndices[17] = 7;

			pIndices[18] = 2; pIndices[19] = 3; pIndices[20] = 7;
			pIndices[21] = 2; pIndices[22] = 7; pIndices[23] = 6;

			pIndices[24] = 1; pIndices[25] = 2; pIndices[26] = 6;
			pIndices[27] = 1; pIndices[28] = 6; pIndices[29] = 5;

			pIndices[30] = 4; pIndices[31] = 5; pIndices[32] = 6;
			pIndices[33] = 4; pIndices[34] = 6; pIndices[35] = 7;

			
			// Create a mesh format suitable for generating shadow volumes.
			demo.m_ppaShadowRenderID[tile][j] = new Array(2);
			demo.m_ppaShadowMesh[tile][j] =	demo.modelShadow.PVRTShadowVolMeshCreateMesh( pVertices, 8, pIndices, 12);

			// Init the mesh
			
			demo.modelShadow.PVRTShadowVolMeshInitMesh(gl, demo.m_ppaShadowMesh[tile][j], demo.m_ppaShadowRenderID[tile][j]);

			// Create the shadow volume
			

			demo.m_ppaShadowVol[tile][j] =	demo.modelShadow.PVRTShadowVolMeshInitVol( demo.m_ppaShadowMesh[tile][j], 0);
		  
			demo.m_ppaVolumeScale[tile][j] = bbox.maxCoords.data[2];
		}


		demo.completeVBO--;	
		// Only generate shadow volumes for the first available LOD per tile
		return;
	    }


/*!****************************************************************************
 @Function		CreateShadowVolumes
 @Description	Builds the shadow meshes and shadow volumes
******************************************************************************/
//void OglES2Navigation3D::CreateShadowVolumes(unsigned int tile)
WebglNavigation3DSim.prototype.createShadowVolumes = function(gl, tile)
{


	for (let i=0; i < this.m_paPVRTCityBlocks[tile].numLod; i++)
	{
		
		//let mdoel = new CPVRTModelPOD()

		let pLod = this.m_paPVRTCityBlocks[tile].paLod[i]; 

		(function(demo, pLod,gl)
		{

			let fs = new PVRFileStream();
		
			fs.Open(getFileLocation( pLod.pszFilename), true, loadShadowVolume,  pLod, demo, tile, gl);
		})( this, pLod,gl);
	
	
		
    }
}


/*!****************************************************************************
 @Function		ReleaseShadowVolumes
 @Description	Releases all shadow volume related data
******************************************************************************/
// OglES2Navigation3D::ReleaseShadowVolumes()
// WebglNavigation3DSim.prototype.releaseShadowVolumes = function()
// {
// 	for (let i=0; i < this.m_uiNumPVRTCityBlocks; i++)
// 	{
// 		for (let j=0; j < this.m_paNumShadowVols[i]; j++)
// 		{
// 			if(this.m_ppaShadowMesh[i])
// 			{
// 				PVRTShadowVolMeshDestroyMesh(this.m_ppaShadowMesh[i][j]);
// 				PVRTShadowVolMeshReleaseMesh(this.m_ppaShadowMesh[i][j]);
// 				PVRTShadowVolMeshReleaseVol(this.m_ppaShadowVol[i][j]);
// 			}
// 		}
// 	 this.m_ppaShadowMesh[i] = null;
// 		 this.m_ppaShadowVol[i] = null;
// 		this.m_ppaVolumeScale[i] = null;
// 	}
// 	 this.m_ppaShadowMesh = null;
// 	this.m_ppaShadowVol = null;
// 	this.m_paNumShadowVols = null;
// 	this.m_ppaVolumeScale = null;
// }


// /*!****************************************************************************
//  @Function		UpdateShadowVolumes
//  @Description	Updates the shadow volumes within a tile.
// ******************************************************************************/
//void OglES2Navigation3D::UpdateShadowVolumes()
WebglNavigation3DSim.prototype.updateShadowVolumes = function(gl)
{
	// Flags: PVRTSHADOWVOLUME_VISIBLE | PVRTSHADOWVOLUME_NEED_CAP_FRONT | PVRTSHADOWVOLUME_NEED_CAP_BACK
	//        0x01                       0x02                              0x04
	const  flags = PVRTSHADOWVOLUME_VISIBLE  | PVRTSHADOWVOLUME_NEED_CAP_FRONT | PVRTSHADOWVOLUME_NEED_CAP_BACK;

	for (let j=0; j < this.m_uiNumPVRTCityBlocks; j++)
	{
		for (let i=0; i < this.m_paNumShadowVols[j]; i++)
		{
		//	PVRTShadowVolSilhouetteProjectedBuild(this.m_ppaShadowVol[j][i], flags, this.m_ppaShadowMesh[j][i], (new PVRVector3*)m_vLightDirection.data, false);
		this.modelShadow.PVRTShadowVolSilhouetteProjectedBuild(gl, this.m_ppaShadowVol[j][i], flags, this.m_ppaShadowMesh[j][i], m_vLightDirection, false, this.m_ppaShadowRenderID[j][i]);
		  }
	}
	gl.bindBuffer(gl.ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

}

// /*!****************************************************************************
//  @Function		RenderShadowVolumes
//  @Description	Renders the shadow volumes using the stencil shadow volumes
//                 algorithm (zfail variant).
// ******************************************************************************/
//void OglES2Navigation3D::RenderShadowVolumes()
WebglNavigation3DSim.prototype.renderShadowVolumes = function(gl)
{
	//	For a detailed explanation on how to use the Stencil Buffer see the training course:	Stencil Buffer.
	gl.TRUE = true;
	// Setup a smaller view frustum for the stencil shadow culling routine, as we only want to have
	// shadows near to the viewer.
	let  mStencilMVPMatrix = {}; 
	if (!m_bRotate)
		//mStencilMVPMatrix = new PVRMatrix4x4.PerspectiveFovRH(this.m_fFOV, this.m_fAspectRatio, this.m_fNearClipPlane, this.m_fNearClipPlane * c_fShadowVolumesMaxDistance, new PVRMatrix4x4::Ogl, m_bRotate) * m_mViewMatrix;
	
		mStencilMVPMatrix = PVRMatrix4x4.multiply(PVRMatrix4x4.createPerspectiveProjection ( this.m_fNearClipPlane,this.m_fNearClipPlane * c_fShadowVolumesMaxDistance, this.m_fFOV, this.m_fAspectRatio ) , m_mViewMatrix);
	
		else
		mStencilMVPMatrix = PVRMatrix4x4.multiply(PVRMatrix4x4.createPerspectiveProjection(this.m_fNearClipPlane, this.m_fNearClipPlane * c_fShadowVolumesMaxDistance, this.m_fFOV, 1.0 / this.m_fAspectRatio) , m_mViewMatrix);

	 let planes = [new PVRVector4(), new PVRVector4(),new PVRVector4(),new PVRVector4()] //[4];
	this.extractViewFrustumPlanes(mStencilMVPMatrix, planes[0], planes[1], planes[2], planes[3]);

	gl.enable(gl.STENCIL_TEST);

	// Calculate the scale factor for the shadow volume extrusion based on the light angle
	let angle_cos =   PVRVector3.dot(  m_vLightDirection , new PVRVector3(0.0, 0.0, -1.0));
	let scalefactor = 1.01;
	if (angle_cos !== 0.0) scalefactor = (1.0 / angle_cos) + 0.01;

	let mMVP = m_mViewProjectionMatrix;

//#ifdef 
if(!USE_INFINITE_FAR_PLANE)
	{
		let mMVP =   m_mProjectionMatrix;
		let cot = (1.0/Math.tan(this.m_fFOV * 0.5));
		mMVP.data[0] = cot / this.m_fAspectRatio;
		mMVP.data[1] = mMVP.data[2] = mMVP.data[3] = 0.0;

		mMVP.data[4] = 0.0;
		mMVP.data[5] = cot;
		mMVP.data[6] = mMVP.data[7] = 0.0;

		mMVP.data[8] = mMVP.data[9] = 0.0;
		mMVP.data[10] = mMVP.data[11] = -1.0;

		mMVP.data[12] = mMVP.data[13] = 0.0;
		mMVP.data[14] = this.m_fNearClipPlane * -2.0;
		mMVP.data[15] = 0.0;

		mMVP = PVRMatrix4x4.multiply( mMVP , m_mViewMatrix);
	}
//#endif

	// Use the shader program that is used for the shadow volumes
	gl.useProgram(m_ShadowVolShader.uiId);

	gl.uniformMatrix4fv(m_ShadowVolShader.uiModelViewProjMatrixLoc,  gl.FALSE, mMVP.data);

	const  afColor = [ 0.4, 1.0, 0.0, 0.2 ];
	gl.uniform4fv(m_ShadowVolShader.uiColourLoc,  afColor);

	let lightDir = m_vLightDirection;
	gl.uniform3fv(m_ShadowVolShader.uiLightDirectionLoc,  lightDir.data);

	//If we want to display the shadow volumes don't disable the colour mask and enable blending
	if(m_abStates[STATE_DEBUG])
	{
		gl.enable(gl.BLEND);
		gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
	}
	else // Disable the colour mask so we don't draw to the colour buffer
		gl.colorMask(gl.FALSE, gl.FALSE, gl.FALSE, gl.FALSE);

	// Disable writing to the depth buffer
	gl.depthMask(gl.FALSE);
	gl.depthFunc(gl.LESS);

	gl.disable(gl.CULL_FACE);
	gl.stencilFunc(gl.ALWAYS, 1, 0xFFFFFFFF);

	gl.stencilOpSeparate(gl.FRONT, gl.KEEP, gl.DECR_WRAP, gl.KEEP);
	gl.stencilOpSeparate(gl.BACK, gl.KEEP, gl.INCR_WRAP, gl.KEEP);

	for (let i=0; i < this.m_uiNumPVRTCityBlocks; i++)
	{
		////console.log("before rendering")
		if (INTERSECT_NONE === this.boundingBoxIntersectsFrustum(this.m_paPVRTCityBlocks[i].boundingbox, planes))
			continue;
////console.log("rendering", this.m_paNumShadowVols[i]);
		for (let j=0; j < this.m_paNumShadowVols[i]; j++)
		{

			
			gl.uniform1f(m_ShadowVolShader.uiVolumeScaleLoc, this.m_ppaVolumeScale[i][j] * scalefactor);
			this.modelShadow.PVRTShadowVolSilhouetteProjectedRender(gl, this.m_ppaShadowMesh[i][j], this.m_ppaShadowVol[i][j], this.m_ppaShadowRenderID[i][j]);
		}
	}
	gl.bindBuffer(gl.ARRAY_BUFFER, null);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

	// Enable Culling as we would like it back
	gl.enable(gl.CULL_FACE);

	// Set the stencil function so we only draw where the stencil buffer isn't 0
	gl.stencilFunc(gl.NOTEQUAL, 0, 0xFFFFFFFF);
	gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);

	if(!m_abStates[STATE_DEBUG])
	{
		// Enable the colour buffer
		gl.colorMask(gl.TRUE, gl.TRUE, gl.TRUE, gl.TRUE);
        // //console.log("gl.true:", gl.TRUE);
		gl.enable(gl.BLEND);

		// Use modulate blending
		gl.blendFunc(gl.DST_COLOR, gl.ZERO);

		// Use the shader program for the scene
		gl.useProgram(m_FullscreenShader.uiId);

		const  afShadowColor =  [0.6, 0.6, 0.6, 1.0 ];
		gl.uniform4fv(m_FullscreenShader.uiColourLoc,  afShadowColor);
		
      // Enable vertex arributes
		gl.enableVertexAttribArray(VERTEX_ARRAY);

		const  afVertexData = [-1, -1,  1, -1,  -1, 1,  1, 1 ];
   if (!this.afVertexDatagl ) {this.afVertexDatagl = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, this.afVertexDatagl);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData), gl.STATIC_DRAW); 
	}
else{
	 gl.bindBuffer(gl.ARRAY_BUFFER, this.afVertexDatagl);
}
					
// Enable vertex arributes
		gl.enableVertexAttribArray(VERTEX_ARRAY);
		gl.vertexAttribPointer(VERTEX_ARRAY, 2, gl.FLOAT, gl.FALSE, 0, 0);

		// Draw the quad
		gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);

		// Disable vertex arributes
		gl.disableVertexAttribArray(VERTEX_ARRAY);

		// Disable blending
		gl.disable(gl.BLEND);
		
	}

	// Enable writing to the depth buffer
	gl.depthMask(gl.TRUE);
	
	gl.depthFunc(gl.LEQUAL);

	gl.disable(gl.STENCIL_TEST);
	gl.bindBuffer(gl.ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

}


return (null)

}


export default WebglNavigation3DSim